
import { agent_roles as agent_roles } from '../components/account/bootstrap';
import { round as _round, random as _random, size as _size } from 'lodash';
import { stage_types, stages_with_probability } from '../data/bootstrap_stages';
// import { createRoot } from 'react-dom/client';
import ReactDOM from 'react-dom';
import { useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

export const staticImagesCdn = (force) => {
	if(force == undefined)force = false;
	if(window.server_type == '2' && !force) return '/';
	return 'https://static.cstmapp.com/';
};

export const asyncImg = (data, cb, skip) => {
	if(skip == undefined) skip = true;
	if(data.v == null || data.v.indexOf('data:image') < 0) return;

	$.post(`/promotions/asyncimg/${data.pid}`, data, (response) => {
		if(cb != undefined) {
			cb(data.k, response[data.k], skip);
			cb(`full_${data.k}`, response[`full_${data.k}`], skip);
		}
	}, 'JSON');
};

export const useDebounce = (value, delay) => {
	const [debouncedValue, setDebouncedValue] = useState(value);
  
	useEffect(() => {
	  const handler = setTimeout(() => {
		setDebouncedValue(value);
	  }, delay);
  
	  return () => {
		clearTimeout(handler);
	  };
	}, [value, delay]);
  
	return debouncedValue;
}

export const MD5 = function(e) {
	function h(a, b) {
		var c, d, e, f, g;
		e = a & 2147483648;
		f = b & 2147483648;
		c = a & 1073741824;
		d = b & 1073741824;
		g = (a & 1073741823) + (b & 1073741823);
		return c & d ? g ^ 2147483648 ^ e ^ f : c | d ? g & 1073741824 ? g ^ 3221225472 ^ e ^ f : g ^ 1073741824 ^ e ^ f : g ^ e ^ f
	}

	function k(a, b, c, d, e, f, g) {
		a = h(a, h(h(b & c | ~b & d, e), g));
		return h(a << f | a >>> 32 - f, b)
	}

	function l(a, b, c, d, e, f, g) {
		a = h(a, h(h(b & d | c & ~d, e), g));
		return h(a << f | a >>> 32 - f, b)
	}

	function m(a, b, d, c, e, f, g) {
		a = h(a, h(h(b ^ d ^ c, e), g));
		return h(a << f | a >>> 32 - f, b)
	}

	function n(a, b, d, c, e, f, g) {
		a = h(a, h(h(d ^ (b | ~c), e), g));
		return h(a << f | a >>> 32 - f, b)
	}

	function p(a) {
		var b = "",
			d = "",
			c;
		for (c = 0; 3 >= c; c++) d = a >>> 8 * c & 255, d = "0" + d.toString(16), b += d.substr(d.length - 2, 2);
		return b
	}
	var f = [],
		q, r, s, t, a, b, c, d;
	e = function(a) {
		a = a.replace(/\r\n/g, "\n");
		for (var b = "", d = 0; d < a.length; d++) {
			var c = a.charCodeAt(d);
			128 > c ? b += String.fromCharCode(c) : (127 < c && 2048 > c ? b += String.fromCharCode(c >> 6 | 192) : (b += String.fromCharCode(c >> 12 | 224), b += String.fromCharCode(c >> 6 & 63 | 128)), b += String.fromCharCode(c & 63 | 128))
		}
		return b
	}(e);
	f = function(b) {
		var a, c = b.length;
		a = c + 8;
		for (var d = 16 * ((a - a % 64) / 64 + 1), e = Array(d - 1), f = 0, g = 0; g < c;) a = (g - g % 4) / 4, f = g % 4 * 8, e[a] |= b.charCodeAt(g) << f, g++;
		a = (g - g % 4) / 4;
		e[a] |= 128 << g % 4 * 8;
		e[d - 2] = c << 3;
		e[d - 1] = c >>> 29;
		return e
	}(e);
	a = 1732584193;
	b = 4023233417;
	c = 2562383102;
	d = 271733878;
	for (e = 0; e < f.length; e += 16) q = a, r = b, s = c, t = d, a = k(a, b, c, d, f[e + 0], 7, 3614090360), d = k(d, a, b, c, f[e + 1], 12, 3905402710), c = k(c, d, a, b, f[e + 2], 17, 606105819), b = k(b, c, d, a, f[e + 3], 22, 3250441966), a = k(a, b, c, d, f[e + 4], 7, 4118548399), d = k(d, a, b, c, f[e + 5], 12, 1200080426), c = k(c, d, a, b, f[e + 6], 17, 2821735955), b = k(b, c, d, a, f[e + 7], 22, 4249261313), a = k(a, b, c, d, f[e + 8], 7, 1770035416), d = k(d, a, b, c, f[e + 9], 12, 2336552879), c = k(c, d, a, b, f[e + 10], 17, 4294925233), b = k(b, c, d, a, f[e + 11], 22, 2304563134), a = k(a, b, c, d, f[e + 12], 7, 1804603682), d = k(d, a, b, c, f[e + 13], 12, 4254626195), c = k(c, d, a, b, f[e + 14], 17, 2792965006), b = k(b, c, d, a, f[e + 15], 22, 1236535329), a = l(a, b, c, d, f[e + 1], 5, 4129170786), d = l(d, a, b, c, f[e + 6], 9, 3225465664), c = l(c, d, a, b, f[e + 11], 14, 643717713), b = l(b, c, d, a, f[e + 0], 20, 3921069994), a = l(a, b, c, d, f[e + 5], 5, 3593408605), d = l(d, a, b, c, f[e + 10], 9, 38016083), c = l(c, d, a, b, f[e + 15], 14, 3634488961), b = l(b, c, d, a, f[e + 4], 20, 3889429448), a = l(a, b, c, d, f[e + 9], 5, 568446438), d = l(d, a, b, c, f[e + 14], 9, 3275163606), c = l(c, d, a, b, f[e + 3], 14, 4107603335), b = l(b, c, d, a, f[e + 8], 20, 1163531501), a = l(a, b, c, d, f[e + 13], 5, 2850285829), d = l(d, a, b, c, f[e + 2], 9, 4243563512), c = l(c, d, a, b, f[e + 7], 14, 1735328473), b = l(b, c, d, a, f[e + 12], 20, 2368359562), a = m(a, b, c, d, f[e + 5], 4, 4294588738), d = m(d, a, b, c, f[e + 8], 11, 2272392833), c = m(c, d, a, b, f[e + 11], 16, 1839030562), b = m(b, c, d, a, f[e + 14], 23, 4259657740), a = m(a, b, c, d, f[e + 1], 4, 2763975236), d = m(d, a, b, c, f[e + 4], 11, 1272893353), c = m(c, d, a, b, f[e + 7], 16, 4139469664), b = m(b, c, d, a, f[e + 10], 23, 3200236656), a = m(a, b, c, d, f[e + 13], 4, 681279174), d = m(d, a, b, c, f[e + 0], 11, 3936430074), c = m(c, d, a, b, f[e + 3], 16, 3572445317), b = m(b, c, d, a, f[e + 6], 23, 76029189), a = m(a, b, c, d, f[e + 9], 4, 3654602809), d = m(d, a, b, c, f[e + 12], 11, 3873151461), c = m(c, d, a, b, f[e + 15], 16, 530742520), b = m(b, c, d, a, f[e + 2], 23, 3299628645), a = n(a, b, c, d, f[e + 0], 6, 4096336452), d = n(d, a, b, c, f[e + 7], 10, 1126891415), c = n(c, d, a, b, f[e + 14], 15, 2878612391), b = n(b, c, d, a, f[e + 5], 21, 4237533241), a = n(a, b, c, d, f[e + 12], 6, 1700485571), d = n(d, a, b, c, f[e + 3], 10, 2399980690), c = n(c, d, a, b, f[e + 10], 15, 4293915773), b = n(b, c, d, a, f[e + 1], 21, 2240044497), a = n(a, b, c, d, f[e + 8], 6, 1873313359), d = n(d, a, b, c, f[e + 15], 10, 4264355552), c = n(c, d, a, b, f[e + 6], 15, 2734768916), b = n(b, c, d, a, f[e + 13], 21, 1309151649), a = n(a, b, c, d, f[e + 4], 6, 4149444226), d = n(d, a, b, c, f[e + 11], 10, 3174756917), c = n(c, d, a, b, f[e + 2], 15, 718787259), b = n(b, c, d, a, f[e + 9], 21, 3951481745), a = h(a, q), b = h(b, r), c = h(c, s), d = h(d, t);
	return (p(a) + p(b) + p(c) + p(d)).toLowerCase()
};

export const getPromoMenus = (menus, promotion) => {
	const getSorted = () => {
		return menus.map((m) => {
			var id = (m.id == undefined) ? m.cid : m.cid;
			m.open = false;
			return m;
		}).sort((a, b) => {
			const a_pos = a?.attributes?.pos ?? a.pos;
			const b_pos = b?.attributes?.pos ?? b.pos;
			return (parseInt(a_pos) < parseInt(b_pos)) ? -1 : 1;
		});
	}

	const getEnabled = (menus) => {
		let promo = promotion;

		return menus.filter((m) => {
			const type = m?.attributes?.type ?? m?.type;
			if(type == 'policy' && promo.policy == undefined) return false;
			if(type == 'landing' && promo.config.disable_landing == 1) return false;
			if(type == 'register' && promo.hide_enter_button == 1) return false;
			if(type == 'brackets' && (promo.brackets_enabled == undefined || promo.brackets_enabled == '0')) return false;
			if(type == 'entries' && promo.public_entries != 1) return false;
			if(type == 'galleries' && promo.galleries_enabled != 1) return false;
			if(type == 'toc' && promo.toc == "") return false;
			if(type == 'winners' && promo.win_published != '1') return false;
			if(type == 'prize_gallery' && (promo.loyalty_enabled == undefined || promo.loyalty_enabled == false)) return false;
			if(type == 'share' && promo.config.share != undefined && promo.config.share.status != '1') return false;

			return true;
		})
	}

	return getEnabled(getSorted());
};

export const getMediaProps = (media) => {
	let media_props = {};

	const type_media = (media.type != undefined) ? media.type : 'image';
	switch(type_media) {
		case 'video':
			media_props.video_url = `https://vimeo.com/${media.vimeo_id}`;
			if (media.hash != undefined){
				media_props.hash = media.hash;
			}
			if(media.video_thumb != undefined)media_props.video_thumb = media.full_path + media.video_thumb;
			else if(media.pictures_id != undefined)media_props.video_thumb = `https://i.vimeocdn.com/video/${media.pictures_id}`;//For old videos && old promos with media_contest
			break;

		case 'youtube':
			media_props.video_url = `https://www.youtube.com/embed/${media.youtube_id}`;
			if(media.full_thumbnail_url != undefined)media_props.thumbnail_url = media.full_thumbnail_url
			else if(media.resolution != undefined)media_props.thumbnail_url = `https://i.ytimg.com/vi/${media.youtube_id}/${media.resolution}`;
			//media_props.video_url = `https://www.youtube.com/embed/${media.youtube_id}`;
			break;

		case 'cover':
			media_props.title = media.title;
			media_props.description = media.description;
			break;

		case 'image':
		default:
			media_props.file = media;
			break;
	}

	return media_props;
};

// SOURCE: https://gist.github.com/gre/1650294
export const ease_function = (type) => {
	const CalcIn = (t, power) => {
		return Math.pow(t, power);
	};

	const CalcOut = (t, power) => {
		const multiplier = (power / 2 == parseInt(power / 2)) ? -1 : 1;
		return 1 - multiplier * CalcIn(t, power);
	};

	const CalcInOut_In = (t, power) => {
		return Math.pow(2, power - 1) * CalcIn(t, power);
	};

	const CalcInOut_Out = (t, power) => {
		const multiplier = (power / 2 == parseInt(power / 2)) ? -1 : 1;
		return 1 - multiplier * Math.pow(2, power - 1) * CalcIn(t, power);
	};

	const EaseIn = (power) => {
		return (t) => { return CalcIn(t, power); }
	};

	const EaseOut = (power) => {
		return (t) => { return CalcOut(t, power); }
	};

	const EaseInOut = (power) => {
		return (t) => { return (t < 0.5) ? CalcInOut_In(t, power) : CalcInOut_Out(t, power); };
	};

	switch(type) {
		case 'linear':
		default:
			return EaseIn(1);

		case 'easeInQuad':
			return EaseIn(2);

		case 'easeOutQuad':
			return EaseOut(2);

		case 'easeInOutQuad':
			return EaseInOut(2);

		case 'easeInCubic':
			return EaseIn(3);

		case 'easeOutCubic':
			return EaseOut(3);

		case 'easeInOutCubic':
			return EaseInOut(3);

		case 'easeInQuart':
			return EaseIn(4);

		case 'easeOutQuart':
			return EaseOut(4);

		case 'easeInOutQuart':
			return EaseInOut(4);

		case 'easeInQuint':
			return EaseIn(5);

		case 'easeOutQuint':
			return EaseOut(5);

		case 'easeInOutQuint':
			return EaseInOut(5);
	}
};

/** SOURCE: https://stackoverflow.com/posts/9851769/revisions **/
export const detectBrowser = () => {
	// Opera 8.0+
	const isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;

	// Firefox 1.0+
	const isFirefox = typeof InstallTrigger !== 'undefined';

	// Safari 3.0+ "[object HTMLElementConstructor]"
	const isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));

	// Internet Explorer 6-11
	const isIE = /*@cc_on!@*/false || !!document.documentMode;

	// Edge 20+
	const isEdge = !isIE && !!window.StyleMedia;

	// Chrome 1 - 79
	const isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);

	// Edge (based on chromium) detection
	const isEdgeChromium = isChrome && (navigator.userAgent.indexOf("Edg") != -1);

	// Blink engine detection
	const isBlink = (isChrome || isOpera) && !!window.CSS;

	let output = {
		firefox:isFirefox,
		chrome:isChrome,
		safari:isSafari,
		opera:isOpera,
		msie:isIE,
		edge:isEdge,
		edgeChromium:isEdgeChromium,
		blink:isBlink,
	};

	return output;
};

// source: http://jsfiddle.net/xLF38/818/
export const getAverageRGB = (imgEl) => {
	var blockSize = 5, // only visit every 5 pixels
		defaultRGB = { r:128, g:128, b:128 }, // for non-supporting envs
		canvas = document.createElement('canvas'),
		context = canvas.getContext && canvas.getContext('2d', { willReadFrequently:true }),
		data, width, height,
		i = -4,
		length,
		rgb = { r:0, g:0, b:0 },
		count = 0;

	if(!context) return defaultRGB;

	height = canvas.height = imgEl.naturalHeight || imgEl.offsetHeight || imgEl.height;
	width = canvas.width = imgEl.naturalWidth || imgEl.offsetWidth || imgEl.width;

	context.drawImage(imgEl, 0, 0);

	try {
		data = context.getImageData(0, 0, width, height);
	} catch(e) {
		/* security error, img on diff domain */
		return defaultRGB;
	}

	length = data.data.length;

	while((i += blockSize * 4) < length) {
		if(data.data[i] != data.data[i + 1] || data.data[i] != data.data[i + 2]) {
			// addon by Marc: we only access the colors with different values (not grayscale) to permit PNG
			// (because the transparent pixels are [0, 0, 0] so it darkens the color)
			++count;
			rgb.r += data.data[i];
			rgb.g += data.data[i + 1];
			rgb.b += data.data[i + 2];
		}
	}

	// ~~ used to floor values
	rgb.r = ~~(rgb.r / count);
	rgb.g = ~~(rgb.g / count);
	rgb.b = ~~(rgb.b / count);

	return rgb;
};

export const UCFirst = (text) => {
	return text[0].toUpperCase() + text.substring(1);
};

export const CamelCaseText = (text) => {
	const label_words = text.split(" ");
	for(let i = 0; i < label_words.length; i++) {
		label_words[i] = label_words[i][0].toUpperCase() + label_words[i].substring(1);
	}
	return label_words.join(" ");
};

export const i18nIntl = (m, intl, case_variant) => {
	if(m == '') return m;
	if(intl == undefined) {
		if(window.server_type != '0') console.error(`Intl attribute missing in i18nIntl for label "${m}"`);
		
		return m;
	}
	let label = intl.formatMessage({ id:m });
	label = ("" + label).replace("***", "");

	if(case_variant == undefined) case_variant = 'normal';
	switch(case_variant) {
		case 'camelcase':
			return CamelCaseText(label);

		case 'lowercase':
			return label.toLowerCase();

		case 'ucfirst':
			return UCFirst(label);

		case 'uppercase':
			return label.toUpperCase();

		case 'normal':
		default:
			return label;
	}
};

export const ensureUrlEndingWithSlash = (url, final_char = '/') => {
	if(url.substr(url.length - 1) == final_char) return url;
	return `${url}${final_char}`;
};

export const affect_color_filter = (p, c0, c1, l) => {
	let r,g,b,P,f,t,h,i=parseInt,m=Math.round,a=typeof(c1)=="string";
	if(typeof(p)!="number"||p<-1||p>1||typeof(c0)!="string"||(c0[0]!='r'&&c0[0]!='#')||(c1&&!a))return null;
	const pSBCr=(d)=>{
	let n=d.length,x={};
	if(n>9){
	[r,g,b,a]=d=d.split(","),n=d.length;
	if(n<3||n>4)return null;
	x.r=i(r[3]=="a"?r.slice(5):r.slice(4)),x.g=i(g),x.b=i(b),x.a=a?parseFloat(a):-1
	}else{
	if(n==8||n==6||n<4)return null;
	if(n<6)d="#"+d[1]+d[1]+d[2]+d[2]+d[3]+d[3]+(n>4?d[4]+d[4]:"");
	d=i(d.slice(1),16);
	if(n==9||n==5)x.r=d>>24&255,x.g=d>>16&255,x.b=d>>8&255,x.a=m((d&255)/0.255)/1000;
	else x.r=d>>16,x.g=d>>8&255,x.b=d&255,x.a=-1
	}return x};
	h=c0.length>9,h=a?c1.length>9?true:c1=="c"?!h:false:h,f=pSBCr(c0),P=p<0,t=c1&&c1!="c"?pSBCr(c1):P?{r:0,g:0,b:0,a:-1}:{r:255,g:255,b:255,a:-1},p=P?p*-1:p,P=1-p;
	if(!f||!t)return null;
	if(l)r=m(P*f.r+p*t.r),g=m(P*f.g+p*t.g),b=m(P*f.b+p*t.b);
	else r=m((P*f.r**2+p*t.r**2)**0.5),g=m((P*f.g**2+p*t.g**2)**0.5),b=m((P*f.b**2+p*t.b**2)**0.5);
	a=f.a,t=t.a,f=a>=0||t>=0,a=f?a<0?t:t<0?a:a*P+t*p:0;
	if(h)return"rgb"+(f?"a(":"(")+r+","+g+","+b+(f?","+m(a*1000)/1000:"")+")";
	else return"#"+(4294967296+r*16777216+g*65536+b*256+(f?m(a*255):0)).toString(16).slice(1,f?undefined:-2)
};

export const colorHEX2RGB = (hex, string = false) => {
	hex = hex.replace(/\#rgb/gi, "rgb");
	
	if(hex.indexOf("#") < 0 || hex.indexOf("rgb") > -1) return hex;

	// Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
	var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
	hex = hex.replace(shorthandRegex, (m, r, g, b) => {
		return r + r + g + g + b + b;
	});

	var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

	var color =  (result) ? [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16), 1] : null;

	if(string && color != null) {
		return `rgba(${color[0]}, ${color[1]}, ${color[2]}, 1)`;
	}

	return color;
};

export const colorVariable2RGB = (rgb) => {
	const css_variable = (rgb.indexOf("--") > 0) ? rgb.substring(rgb.indexOf("--"), rgb.indexOf(")")) : rgb;

	const color_parts = getComputedStyle(document.querySelector('body')).getPropertyValue(css_variable);

	if(color_parts == '') return 'rgba(0,0,0,1)';

	const color_parts_arr = color_parts.split(",");

	if(color_parts_arr.length == 3) return `rgba(${color_parts},1)`;
	return `rgba(${color_parts})`;
};

export const colorComponents = (rgb) => {
	if(rgb.indexOf("#") != -1) return colorHEX2RGB(rgb);
	if(rgb.indexOf("--") != -1) rgb = colorVariable2RGB(rgb);

	rgb = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
	return [rgb[1], rgb[2], rgb[3], 1];
};

export const colorToArray = (color, return_alpha = false) => {
	if(typeof(color) != 'string') return color;
	if(color == undefined || color === false) return false;
	if(color.indexOf("var(") != -1) return false;
	if(color.indexOf("--") != -1) return false;

	color = color.replace(/\#rgb/gi, "rgb");
	if(color.indexOf("#") != -1) return hexToRGB(color, false, return_alpha);
	if(color.indexOf("rgb") == -1) return false;
	if(color.indexOf("rgba(false") != -1) {
		if(return_alpha) return [0, 0, 0, 1];
		return [0, 0, 0];
	}

	const rgb = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/i);
	//const rgb = color.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
	let color_arr = [rgb[1], rgb[2], rgb[3]];
	if(return_alpha) color_arr.push((rgb[4] != undefined) ? rgb[4] : 1);

	return color_arr;
};

//rgbA and rgbB are arrays, amountToMix ranges from 0.0 to 1.0
export const colorMixer = (rgbA, rgbB, amountToMix, alpha = 1) => {
	return `rgba(${rgbA[0]}, ${rgbA[1]}, ${rgbA[2]}, ${alpha})`;

	//colorChannelA and colorChannelB are ints ranging from 0 to 255
	const colorChannelMixer = (colorChannelA, colorChannelB) => {
		var channelA = colorChannelA * amountToMix;
		var channelB = colorChannelB * (1 - amountToMix);
		return parseInt(channelA + channelB);
	};

	const r = colorChannelMixer(rgbA[0], rgbB[0]);
	const g = colorChannelMixer(rgbA[1], rgbB[1]);
	const b = colorChannelMixer(rgbA[2], rgbB[2]);
	return `rgb(${r}, ${g}, ${b}, ${alpha})`;
};

export const hexToRGB = (hex_color, return_as_string, return_alpha) => {
	if(return_as_string == undefined) return_as_string = false;
	if(return_alpha == undefined) return_alpha = false;

	hex_color = hex_color.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b) => {
		return r + r + g + g + b + b;
	});

	const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex_color);

	let color_arr = (result) ? [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)] : [0, 0, 0];
	if(return_alpha) color_arr.push(1);

	if(!return_as_string) return color_arr;
	
	return `rgba(${color_arr.join(", ")})`;
};

export const desaturate_color = (color, percent, return_rgb) => {
	if(return_rgb == undefined) return_rgb = true;

	const col = colorComponents(color);
	const gray = col[0] * 0.3086 + col[1] * 0.6094 + col[2] * 0.0820;

	const r = Math.round(col[0] * percent + gray * (1 - percent));
	const g = Math.round(col[1] * percent + gray * (1 - percent));
	const b = Math.round(col[2] * percent + gray * (1 - percent));

	const rgb = `rgba(${r}, ${g}, ${b}, 1)`;

	return (return_rgb) ? rgb : RGB_2_HEX(rgb);
};

export const getPromotionMainColor = (promo) => {
	return promo?.layout_props?.color?.main_color ?? 'rgba(30, 34, 170, 1)';
};

export const getPromotionTextColor = (promo) => {
	return promo?.layout_props?.text?.text_color ?? 'rgba(0, 0, 0, 1)';
};

export const getPromotionBgColor = (promo) => {
	return promo?.layout_props?.color?.background_color ?? 'rgba(255, 255, 255, 1)';
};

export const getRandomColorHEX = () => {
	return `rgba(${Math.ceil(255 * Math.random())}, ${Math.ceil(255 * Math.random())}, ${Math.ceil(255 * Math.random())}, 1)`;
};

export const getRandomInt = (min, max) => {
	return Math.round(Math.random() * (max - min)) + min;
};

export const stageSorting = (stages, stages_mosaic_sort_mode) => {
	if(!stages) return;

	if(stages_mosaic_sort_mode != undefined && stages_mosaic_sort_mode == 'manual') {
		stages.sort((a, b) => ((a.Stage.pos < b.Stage.pos) ? -1 : 1));
		return;
	}

	stages.sort((a, b) => ((a.Stage.start_date < b.Stage.start_date) ? -1 : 1));
};

export const base64ToBytes = (base64) => {
	// Eliminar la metadata si está presente (por ejemplo, "data:image/png;base64,")
	var base64WithoutMetadata = base64.split(',')[1] || base64;

	// Decodificar la cadena Base64 y contar la longitud
	var binaryString = atob(base64WithoutMetadata);
	var byteLength = binaryString.length;

	return byteLength;
}

export const getFileSize = (size_by_unit, num_decimals = 2, initial_unit = 'B') => {
	if(isNaN(parseInt(size_by_unit))) return "";

	const thresh = 1024;
  
	if(Math.abs(size_by_unit) < thresh) {
		return `${size_by_unit} ${initial_unit}`;
	}
  
	const default_units = ['B','KB', 'MB', 'GB', 'TB'];
	const units =  default_units.slice(default_units.indexOf(initial_unit) + 1);
	
	let u = -1;
	const r = 10 ** num_decimals;

	do {
		size_by_unit /= thresh;
		++u;
	} while(Math.round(Math.abs(size_by_unit) * r) / r >= thresh && u < units.length - 1);

	const bytes_str = (size_by_unit == parseInt(size_by_unit)) ? size_by_unit : size_by_unit.toFixed(num_decimals);

	return `${bytes_str} ${units[u]}`;
};

export const RGB_2_HEX = (rgb, return_hash) => {
	if(return_hash == undefined) return_hash = true;

	if(rgb.indexOf('#') !== -1) {
		if(!return_hash) return rgb.replace("#", "");
		return rgb;
	}

	if(rgb.indexOf("rgb") == -1) {
		return false;
	}

	rgb = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
	var rgb_return = (rgb && rgb.length === 4) ? (("0" + parseInt(rgb[1],10).toString(16)).slice(-2) + ("0" + parseInt(rgb[2],10).toString(16)).slice(-2) + ("0" + parseInt(rgb[3],10).toString(16)).slice(-2)) : '';
	if(rgb_return != '' && return_hash) rgb_return = "#" + rgb_return;

	return rgb_return;
};

export const isColorBright = (hex_color, contrast_threshold) => {
	const hexdec = (hex_string) => {
		hex_string = (hex_string + '').replace(/[^a-f0-9]/gi, '');
		return parseInt(hex_string, 16);
	};

	if(hex_color == '' || hex_color === false) hex_color = '#C3C3C3';

	const detect_color_scheme = window?.detect_color_scheme ?? false;
	const color_scheme = (detect_color_scheme) ? (window?.color_scheme ?? 'light') : 'light';

	if(typeof(contrast_threshold) == 'undefined') contrast_threshold = (color_scheme == 'light') ? 120 : 120;

	if(hex_color.indexOf('#') === -1) hex_color = RGB_2_HEX(hex_color);
	if(hex_color === false) return false;

	const pre = (hex_color.indexOf('#') == -1) ? 0 : 1;

	const rr = hexdec(hex_color.substring(0 + pre, 2 + pre));
	const gg = hexdec(hex_color.substring(2 + pre, 4 + pre));
	const bb = hexdec(hex_color.substring(4 + pre, 6 + pre));

	const contrast = Math.sqrt((rr * rr * 0.241) + (gg * gg * 0.691) + (bb * bb * 0.068));

	return (contrast >= contrast_threshold) ? true : false;
};

export const getTokenColors = (token, fallback = 'rgba(60, 70, 200, 1)', force_color = false) => {
	const prize_color = (!force_color) ? (token?.color ?? fallback) : 'rgba(127, 127, 127, 1)';
	const is_prize_color_bright = isColorBright(prize_color);

	return {
		'--main-color':colorToArray(prize_color),
		'--text-color':(is_prize_color_bright) ? '0, 0, 0' : '255, 255, 255',
	};
};

export const calculatePercentage = (value, total) => {
	return `${formatNumber((100 * value / total), 2)}%`;
};

export const parseFontName = (font_name) => {
	return font_name.replace(/\+/g, " ");
};

export const stagesForPrize = (stages, _stage_types, assignation, i18n, skip_void) => {
	let stages_list = [];
	if(skip_void == undefined) {
		const empty_stage_label = (assignation == 5) ? `-- ${i18n("Please choose a stage")} --` : `${i18n("Any participation stage")} (${i18n("default")})`;
		stages_list.push({ k:'', v:empty_stage_label });
	}

	stages.filter((s) => {
		switch(parseInt(assignation)) {
			case 5:
				if(!stages_with_probability.includes(parseInt(s.Stage.promotion_type_id))) return false;
				break;

			case 3:
				if(s.Stage.promotion_type_id == '29') return false;
		}
		return true;
	}).map((_stage) => {
		const stage = _stage.Stage;
		let stage_name = "";
		if(stage.display_title != undefined && stage.display_title != "") {
			stage_name = stage.display_title;
		} else {
			let stage_type = _stage_types.find((obj) => { return obj.id == stage.promotion_type_id; });
			if(stage_type == undefined) stage_type = {};
			stage_name = i18n(stage_type?.name ?? "Unknown stage type");
		}
		stages_list.push({ k:stage.id, v:stage_name });
	});

	return stages_list;
};

export const getStageName = (stage, i18n) => {
	if(stage.display_title) return stage.display_title;
	return `${i18n("Stage")} #${stage.id}`;
};

export const getStageNameV2 = (stage, i18n) => {
	if(stage.display_title) return stage.display_title;
	const stage_type = stage_types.find((st) => {return stage.promotion_type_id == st.id});
	if(stage_type)return i18n(stage_type.name);
	return `${i18n("Stage")} #${stage.id}`;
};

export const isRemoteDb = () => {
	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);
	return (urlParams.has('remotedb')) ? true : false;
};

export const getRemotedbUrl = (url, _hash, add_origin = true) => {
	let hash = (_hash != undefined) ? `#${_hash}` : '';
	if(hash != '') hash = hash.replace(/##/, "#");	// we replace in case "_hash" came with "#" sign at the beginning
	
	// quick scape in case the layout already has defined if we are NOT in remote:
	if((window?.is_remote_db ?? false) === false) return `${url}${hash}`;

	if(!isRemoteDb()) return `${url}${hash}`;

	const url_parts = url.split("?");
	const url_has_get = (url_parts.length > 1) ? url_parts[1] : false;

	let queryParams = [];
	if(url_has_get !== false) queryParams.push(url_has_get);
	queryParams.push('remotedb');

	return `${(add_origin) ? window.location.origin : ''}${url_parts[0]}?${queryParams.join("&")}${hash}`;
};

export const cleanGetParamUrl = (param_name) => {
	let _url = new URL(window.location);
	_url.searchParams.delete(param_name);
	window.history.pushState({}, '', _url);
}

export const autotranslateText = (text, apply, intl) => {
	if(text == undefined || text == "") return null;

	if(apply == undefined) apply = true;
	if(!apply || typeof text != 'string') return text;
	
	const i18n = (m, c) => i18nIntl(m, intl, c);

	return i18n(text);
};

export const waitForElementInDOM = (selector) => {
	return new Promise(resolve => {
		if(document.querySelector(selector)) {
			return resolve(document.querySelector(selector));
		}

		const observer = new MutationObserver((mutations) => {
			if(document.querySelector(selector)) {
				observer.disconnect();
				resolve(document.querySelector(selector));
			}
		});

		observer.observe(document.body, {
			childList:true,
			subtree:true,
		});
	});
};

export const getRoundLabel = (bracket, round, return_only_defaults, intl) => {
	const i18n = (m, c) => i18nIntl(m, intl, c);

	if(bracket == undefined) return "";

	if(round == undefined) round = 1;
	if(return_only_defaults == undefined) return_only_defaults = false;

	let total_rounds = parseInt(bracket.num_rounds);
	if(parseInt(round) > total_rounds) return i18n("Winner", 'uppercase');

	let round_label = bracket[`round_${round}`];

	if(round_label == "" || round_label == undefined || return_only_defaults) {
		round_label = `${i18n("Round")} ${round}`;
		return round_label;
	}

	return round_label;
};

export const formatNumber = (number, num_decimals, enable_int = false) => {
	if(num_decimals == undefined) num_decimals = 2;
	if(isNaN(number)) number = 0;

	const multiplier = (num_decimals > 0) ? Math.pow(10, num_decimals) : 1;

	const _return = parseFloat(Math.round(number * multiplier) / multiplier);

	// if enable_int is true, and the value has its decimals being 0, we return the integer number (i.e. without decimals):
	if(enable_int && _return == parseInt(_return)) return parseInt(_return);

	return _return.toFixed(num_decimals);
};

export const countDecimals = (float) => {
	if(Math.floor(float.valueOf()) === float.valueOf()) return 0;
	return float.toString().split(".")[1].length || 0;
}

/* An extended version for obj?.prop but also evaluating if is different of "" */
export const isNotEmpty = (obj, prop, empty_value = ["", " "], include_false = true) => {
	if(obj == undefined) return false;
	if(obj[prop] == undefined) return false;
	if(empty_value.length > 0 && empty_value.includes(obj[prop])) return false;
	if(include_false && obj[prop] === false) return false;
	return true;
};

/* An extended version for obj?.prop but also evaluating if is different of "" */
export const isEmpty = (obj, prop, empty_value = ["", " "], include_false = true) => {
	if(obj == undefined) return true;
	if(obj[prop] == undefined) return true;
	if(empty_value.length > 0 && empty_value.includes(obj[prop])) return true;
	if(include_false && obj[prop] === false) return true;
	return false;
};

export const isEmptyStr = (value) => {
	return (
		value == null || // null o undefined
		(typeof value === "string" && value.trim() === "") ||
		(Array.isArray(value) && value.length === 0) ||
		(typeof value === "object" && !Array.isArray(value) && Object.keys(value).length === 0)
	);
};

export const defaultValue = (obj, prop,default_value, empty_value = ["", " "]) => {
	return isEmpty(obj, prop, empty_value) ? default_value : obj[prop];
}

export const milesNumber = (num, value_if_empty = '-') => {
	if(!num || num == 'NaN') return value_if_empty;
	if(num == 'Infinity') return '&#x221e;';
	num = num.toString().replace(/\$|\,/g, '');
	if(isNaN(num)) num = "0";
	let sign = (num == (num = Math.abs(num)));
	num = Math.floor(num * 100 + 0.50000000001);
	let cents = num % 100;
	num = Math.floor(num / 100).toString();
	if(cents < 10) cents = "0" + cents;
	for(var i = 0; i < Math.floor((num.length - (1 + i)) / 3) ; i++) {
		num = num.substring(0, num.length - (4 * i + 3)) + '.' + num.substring(num.length - (4 * i + 3));
	}

	return (cents > 0) ? (((sign) ? '' : '-') + num + ',' + cents) : ((sign) ? '' : '-') + num;
};

export const parseIfString = (data) => {
    if (typeof data === "string") {
        try {
            return JSON.parse(data);
        } catch (e) {
            console.error("Error al parsear el string:", e);
            return null; // O puedes devolver el string original si prefieres
        }
    }
    return data; // Ya es un objeto, se devuelve tal cual
}


export const adaptHeightOnWidget = (forced_height, delay) => {
	if(typeof(adaptWidgetHeight) == 'function' && window.in_widget != undefined && window.in_widget) {
		//if(delay == undefined) delay = 1;	// in milliseconds

		//const t = setTimeout(() => {
			adaptWidgetHeight(forced_height);
		//}, delay);
	}
};

export const generateUUID = () => {
	let d = new Date().getTime();
	const uuid = 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
		var r = (d + Math.random() * 16) % 16 | 0;
		d = Math.floor(d / 16);
		return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
	});

	// we add a "_" char at the beggining because some situations don't accept items with an ID starting with a digit
	return `_${uuid}`;
};

export const checkIfNotEmpty = (v, eval_space = false) => {
	let is_empty = true;
	if(v != undefined && v != "") {
		is_empty = false;
		if(eval_space && v == " ") is_empty = true;
	}
	return is_empty;
};

export const escapeRegExp = (text) => {
	return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
};

export const getMenuDefaultIcon = (m) => {
	let icon = m.config.class;

	if(icon == null || icon == "") {
		switch(m.type) {
			case 'landing':
				return 'knk-start';

			case 'register':
				return "knk-play";

			case 'entries':
				return "knk-user";

			case 'winners':
				return "knk-winners";

			case 'toc':
				return "knk-toc";

			case 'policy':
				return "knk-zipped";

			case 'share':
				return "knk-share";

			case 'networks':
				return "knk-networks";
		}
	}

	return icon;
};

export const adaptGameToContainer = (cb, item = '.gui_game_wrapper') => {
	const optimized_height_for_widget = (window.parent_location_w != undefined && window.parent_location_h != undefined) ? (Math.min(window.parent_location_w, window.parent_location_h) + 70) : 700;
	adaptHeightOnWidget(optimized_height_for_widget);
	const container_width = document.querySelector(item)?.clientWidth;
	if(cb != undefined) cb(container_width);

	fitPreviewToContainer();
};

export const getPlatformName = (platform, abreviation = false, domain = false) => {
	const available_platforms = [
		{ k:'-1', v:"Local", abrev:'local', domain:'http://pr2.local.easypromosapp.com/' },
		{ k:'0', v:"basic", abrev:'bs', domain:window.basic_base_url },
		{ k:'basic', v:"basic", abrev:'bs', domain:window.basic_base_url },
		{ k:'1', v:"Premium", abrev:'pr', domain:window.premium_base_url },
		{ k:'premium', v:"Premium", abrev:'pr', domain:window.premium_base_url },
		{ k:'2', v:"White Label", abrev:'wl', domain:window.wl_base_url },
		{ k:'wl', v:"White Label", abrev:'wl', domain:window.wl_base_url },
	];

	var found_platform = available_platforms.filter((obj) => { return (platform == obj.k) })[0];
	if(found_platform == undefined) return "Error platform";
	if(abreviation)return found_platform.abrev;
	if(domain)return found_platform.domain;
	return found_platform.v;
};

export const isPromotionAGame = (promo_type_id) => {
	const game_types_arr = ['21', '22', '23', '24', '28', '29', '30','34','39','43','47','48'];
	return inArray(promo_type_id, game_types_arr);
};

export const stringifyArrayOfItems = (items, last_separator = " and ", main_separator = ", ") => {
	if(items == undefined || items.length == 0) return "";
	if(items.length == 1) return items[0];
	const items_arr = [];
	items.map((pos, p) => {
		if(p == items.length - 1) return;
		items_arr.push(pos);
	});

	return `${items_arr.join(main_separator)}${last_separator}${items[items.length - 1]}`;
};

//Fluxe 1 (Mention + Hashtag) + Fluxe 2 (Multimedia Contest, Voting Contest, Hashtags Contest)
export const withInstagramIntegration = (id) => {//promotion.promotion_type_id
	const _promotion_types = [2, 3, 15, 36, 45, 55, 56, 58];
	return _promotion_types.map(String).includes(String(id));
}

export const formatBigNumber = (number) => {
	// Returns a number such as 12345 as 54321
	const reversedNum = (num) => {
		return num.toString().split('').reverse().join('');
	};
	
	// Returns the amount of decimal positions in a number
	const countDecimals = (num) => {
		if(Math.floor(num.valueOf()) === num.valueOf()) return 0;
		return (num.toString().split(".")?.[1] ?? []).length || 0;
	};
	
	const getDecimalPartOfNumber = (num) => {
		// We need to do it this way instead of something like "num - parseInt(num)" to avoid semi-rounded decimal parts
		// (i.e. numbers such as 1234567.89 return a decimal part of 1234567.8899999998975545)

		// So first we need to know how many decimals are in the number:
		const number_of_decimals = countDecimals(num);
	
		// After we get the decimal part of the number:
		const decimal_part = num % 1;	// using module 1 we get the values smaller than the unit (i.e. the decimals of any number of any given size)
	
		// Finally, we multiply the decimal part with the number of decimal positions and we round the nomber to avoid the extra decimal positions:
		return Math.round(Math.pow(10, number_of_decimals) * decimal_part);
	};	

	if(number < 1000) return number;

	const us_format = (window.is_spanish) ? false : true;	// TO DO: get this preference from somewhere else (maybe the account country)

	const mil_separator = (us_format) ? "," : ".";
	const comma_separator = (us_format) ? "." : ",";

	const int_part = parseInt(number);
	const decimal_part = getDecimalPartOfNumber(number);

	// We get the number broken into an array of maximum 3 digits starting from the units position (end of the number)
	// (i.e. 12345 => ['12', '345'])
	const reverse_parts = reversedNum(int_part).match(/.{1,3}/g).reverse();

	const ok_parts = [];
	reverse_parts.map((part) => {
		ok_parts.push(reversedNum(part));
	});

	return `${ok_parts.join(mil_separator)}${(decimal_part > 0) ? `${comma_separator}${decimal_part}` : ''}`;
};

export const generateRouletteCanvas = (prizes, config) => {
	if(config == undefined) {
		config = {
			slices:12,
			no_prize:6,
		}
	}

	var qty = {};
	var indexed = {};
	var total = 0;

	config.slices = parseInt(config.slices);
	config.no_prize = parseInt(config.no_prize);

	if(config.slices < prizes.length + config.no_prize) config.slices = prizes.length + config.no_prize;

	var cloned_prizes = prizes.map((p) => { return {...p} });

	//In order to avoid prize quantity discrepance we calculate the max slices allowed
	var max_slice_size = Math.ceil(config.slices/prizes.length);

	for(var i in cloned_prizes) {
		qty[cloned_prizes[i].id] = cloned_prizes[i].qty;
		total += parseInt(cloned_prizes[i].qty);
		indexed[cloned_prizes[i].id] = cloned_prizes[i];
	}

	var prize_slots = config.slices - config.no_prize;
	var remaining = prize_slots;
	var slices = [];



	// RECOVER TO AVOID PROBLEMS IN BUILDER. REVIEW THIS AFTER XMAS.
	for(var i in qty) {
		if (config.uniform) {
			slices.push({index:i, prop:1/cloned_prizes.length})
			continue;
		}
		slices.push({ index:i, prop:parseInt(qty[i]) / total});
	}
		/*
	if(config.odds) {
		const total_odds = 1000 - parseInt(config.odds[0]);
		for(var i in config.odds) {
			if (i == '0') continue;
			slices.push({ index:i, prop:parseInt(config.odds[i]) / total_odds});
		}
	} else {
		for(var i in qty) {
			slices.push({ index:i, prop:parseInt(qty[i]) / total});
		}
	}*/
	slices = slices.sort((a ,b)=> (a.prop > b.prop ? 1 : -1));

	if (config.uniform) {
		slices = slices.sort((a ,b)=> (a.prop < b.prop ? 1 : -1));
		for (var i=0; i < prize_slots; i++) {
			let d = slices[i % slices.length];
			if (indexed[d.index].slices == undefined) indexed[d.index].slices = 0;
			indexed[d.index].slices++;
		}
	}
	else {
		var index = 0;
		var assigned_slices = 0;
		for(var i in slices) {
			var d = slices[i];
	
			indexed[d.index].slices = Math.max(1, Math.floor(prize_slots * d.prop));
	
			//If the number of slices equal to the number of prizes we cap at 1 despite the proportions
			if(slices.length == prize_slots) indexed[d.index].slices = 1;
	
			if(indexed[d.index].slices > max_slice_size) indexed[d.index].slices = max_slice_size;
	
			remaining -= indexed[d.index].slices;
			assigned_slices += indexed[d.index].slices;
			index++;
	
			if(index == cloned_prizes.length && remaining != 0) indexed[d.index].slices += remaining;
		}
	}
	
	//We need to adjust the slices if we screw up
	while(assigned_slices > prize_slots) {
		for(var i in indexed) {
			if(indexed[i].slices == 1) continue;

			indexed[i].slices--;
			assigned_slices --;
			if(assigned_slices == config.slices) break;
		}
	}

	// Distribute "No prize" sloths in even spaces
	var pos = (config.no_prize == 0) ? config.slices : config.slices / config.no_prize;
	var roulette = {};

	for(var i = 0; i < parseInt(config.no_prize); i++) {
		roulette[Math.floor(pos * i)] = { id:0 };
	}

	var target = 0;
	for(var i in cloned_prizes) {
		// Distribute equalry starting on index
		pos = Math.round(config.slices / cloned_prizes[i].slices);
		// If the pos is ecual to the slices then add 6
		// $pos = $config['slices'] / 2;
		var onlyone = (pos == config.slices) ? true : false;

		for(var j = 0; j < cloned_prizes[i].slices; j++) {
			var t = 2 * i +1;

			// Target is the starting odd plus the sum
			target = (onlyone) ? Math.floor(target + config.slices / 2) % config.slices : ((j*pos) + t) % config.slices;

			// If the pos is pair go to next
			while(roulette[target] != undefined) {
				target++;
				target = target % config.slices;
			}

			roulette[target] = { id:cloned_prizes[i].id };
		}
	}

	return Object.values(roulette);
};

export const folderIdPath = (id) => {
	const prefix = String(id).slice(-2);
	const initial_prefix = prefix.length < 2 ? '0'+prefix : prefix;
	const second_prefix = id.length < 2 ? '0'+id : id;
	return initial_prefix+"/"+second_prefix+"/"
}

export const imgPath = (bucket, id, folder) => {
	var str = '//storage.googleapis.com/'+bucket+'/';
	return str+folderIdPath(id)+folder+"/";
};

export const checkMediaRecorderEnabled = () => {
	let is_enabled = false;

	if(window.MediaRecorder != undefined) {
		if(/chrome/i.test(navigator.userAgent)) {
			const chrome_info = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
			const chrome_version = parseInt(chrome_info[2], 10);

			if(window.MediaRecorder.isTypeSupported('video/webm') && chrome_version > 49) {
				is_enabled = true;
			}
		}

		if(/Firefox/i.test(navigator.userAgent)) {
			const firefox_info = navigator.userAgent.match(/Firefox\/([0-9]+)\./);
			const firefox_version = parseInt(firefox_info[1], 10);
			if(window.MediaRecorder.isTypeSupported('video/webm;codecs=vp8,opus') && firefox_version > 43) {
				is_enabled = true;
			}
		}
	}

	return is_enabled;
};

export const parseClasses = function(classname, class_obj, item_type) {
	if(item_type == undefined) item_type = false;

	if(classname == undefined) classname = '';
	var classes = classname.split(" ");

	// default values if no class_obj is passed
	if(class_obj == undefined) class_obj = {};

	switch(item_type) {
		case 'container':
			if(class_obj['bg'] == undefined) class_obj['bg'] = 'main_bg';
			if(class_obj['padding'] == undefined && class_obj['padding'] !== false) class_obj['padding'] = 'big';
			break;

		case 'range':
			if(class_obj['thickness'] == undefined) class_obj['thickness'] = 'thin';
			break;

		case 'textarea':
		case 'richeditor':
		case 'smarttagsselector':
			if(class_obj['v_size'] == undefined) class_obj['v_size'] = 'normal';
			break;

		case 'matrixselector':
			if(class_obj['size'] == undefined) class_obj['size'] = 30;
			break;

		case 'tabs':
			if(class_obj['background'] == undefined || class_obj['background'] !== false) {
				class_obj['background'] = 'main_bg';
			} else if(class_obj['background'] === false) {
				class_obj['background'] = 'without_bg';
			}
			break;

		case 'video_play_btn':
			if(class_obj['button_size'] == undefined) class_obj['button_size'] = 'normal';
			break;
	}
	
	switch(item_type) {
		case 'generic_item':
		case 'buttons':
		case 'container':
		case 'ribbons':
			break;
			
		default:
			// ideally, "size" class should be replaced with "width" and add an "align:row", but meanwhile, we do this:
			if(class_obj['size'] != undefined && class_obj['align'] == undefined) class_obj['align'] = 'row';

			// if no input width is specified, we force it to be 100% width:
			if(class_obj['width'] == undefined && class_obj['size'] == undefined) class_obj['width'] = 100;
			break;
	}

	for(var i in class_obj) {
		switch(i) {
			case 'align':
				switch(class_obj[i]) {
					case 'row':
						classes.push('gui_sided_input');
						break;

					case 'column':
					default:
						break;
				}
				break;

			case 'button_size':
				classes.push(`${class_obj[i]}_button`);
				break;

			case 'padding':
				if(class_obj[i] !== false) classes.push(`gui_is_padded_${class_obj[i]}`);
				break;

			case 'type':
				if(class_obj[i] == 'small') classes.push('gui_small_input');
				break;

			case 'thickness':
				classes.push(`gui_${class_obj[i]}_slider`);
				break;

			case 'width':
			case 'size':
				if(class_obj[i] != undefined && class_obj[i] !== false) classes.push(`width_${class_obj[i]}`);
				break;

			case 'v_size':
				switch(class_obj[i]) {
					case 'small':
						classes.push('small_textarea');
						break;

					case 'big':
						classes.push('x_textarea');
						break;

					case 'huge':
						classes.push('xx_textarea');
						break;

					case 'normal':
					default:
						break;
				}
				break;

			case 'first':
			case 'in_top':
				classes.push((class_obj[i]) ? 'in_top' : 'not_in_top');
				break;

			case 'contents':
				classes.push(`contains_${class_obj[i]}`);
				break;

			case 'icon':
			default:
				if(class_obj[i] !== false) {
					classes.push(class_obj[i]);
				}
				break;
		}
	}

	return classes.filter((i) => (i != "" && i != " ")).join(" ");
};

export const formatCurrencyPrice = (price, currency = 'USD') => {
	if(price == undefined) return 0;

	return `${((currency.toLowerCase() == 'usd') ? "$" : "")}${price} ${currency}`;
};

export const throwErrorEvent = (error_status) => {
	if(error_status < 400) return;
	if(error_status >= 500) return;
	document.dispatchEvent(new Event('expired_session'));
};

export const getDaysOfTheWeeks = (starts_on = 1) => {
	let days_of_the_week = [
		{ k:2, v:"Tuesday" },
		{ k:3, v:"Wednesday" },
		{ k:4, v:"Thursday" },
		{ k:5, v:"Friday" },
	];

	const monday = { k:1, v:"Monday" };
	const saturday = { k:6, v:"Saturday" };
	const sunday = { k:0, v:"Sunday" };

	switch(starts_on) {
		case 0:
			// starts on sunday (America)
			return [sunday, monday, ...days_of_the_week, saturday];

		case 6:
			// starts on saturday (Middle East)
			return [saturday, sunday, monday, ...days_of_the_week];

		case 1:
		default:
			// starts on monday (Europe)
			return [monday, ...days_of_the_week, saturday, sunday];
	}
};

export const convertObjectToArray = (obj) => {
	var arr = [];
	$.each(obj, (i, item) => {
		(typeof(item) == 'string') ? arr.push({ k:i, v:item }) : arr.push(Object.assign({}, { key:i }, item));
	});

	return arr;
};

export const getInitials = (user) => {
	const isEmojiFirstCharacter = (str) => {
		if(str.indexOf("[ ") > -1) {
			// to avoid the "[ Your Name ]" in SingleGallery preview
			return false;
		}

		if(str.indexOf("asypromos") > -1) {
			// to avoid the "[Easypromos]" or "[easypromos]" in Email preview
			return false;
		}

		const emojiRegex = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|[\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|[\ud83c[\ude32-\ude3a]|[\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;
	
		const split = str.split(/([\uD800-\uDBFF][\uDC00-\uDFFF])/);
		for(let i = 0; i < split.length; i++) {
			let char = split[i].trim();
			if(char != "") {
				return (char.match(emojiRegex)) ? char : false;
			}
		}
	
		return false;
	};

	const getFirstCharacter = (_str) => {
		if(_str == "") return "";
		return (_str + "").replace(/[\@\_\-\[\]\.\,]/g, "").trim().substring(0, 1);
	};

	const nickname = (user.name != undefined && user.name != "") ? user.name : false;
	const username = (user.username != undefined && user.username != "") ? user.username : false;
	const first_name = (user.first_name != undefined && user.first_name != "") ? user.first_name : false;

	let usable_name = false;
	if(nickname) {
		usable_name = nickname;
	} else if(username) {
		usable_name = username;
	} else if(first_name) {
		usable_name = first_name;
	}

	if(usable_name == "") return "-";

	const is_emoji = isEmojiFirstCharacter(usable_name);

	if(is_emoji) return is_emoji;

	return getFirstCharacter(usable_name);
};

export const fitPreviewToContainer = (cb) => {
	if(cb != undefined) cb();
	return;
};

export const preventSelection = (status) => {
	if(status) {
		$('html').addClass('gui_prevent_user_selection');
	} else {
		$('html').removeClass('gui_prevent_user_selection');
	}
};

export const addHttpsIfMissing = (url) => {
	if (url.trim() !== "") {
	  if (url.indexOf("http://") !== 0 && url.indexOf("https://") !== 0) {
		url = "https://" + url;
	  }
	}
	return url;
  }

export const validateURL = (str, return_parts = false, expreg_path = false, expreg_query = false) => {

	let port_and_path = '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*';
	if(expreg_path) port_and_path = expreg_path;
	let query_string = '(\\?[;&a-z\\d%_.~+=-]*)?';
	if(expreg_query) query_string = expreg_query;

	const pattern = new RegExp('^((https?:)?\\/\\/)?'+ // protocol
		'((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
		'((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
		port_and_path + // port and path
		query_string + // query string
		'(\\#[-a-z\\d%_.~+/]*)?$','i'); // fragment locater
		
	const parts = pattern.test(str);
	if(!parts) {
		return false;
	} else {
		return (!return_parts) ? true : str.match(pattern);
	}
};

export const getValidUrl = (url = "", secure = true) => {
	let newUrl = window.decodeURIComponent(url);
	newUrl = newUrl.trim().replace(/\s/g, "");

	let protocol = 'http' + (secure ? 's' : '');

	if(/^(:\/\/)/.test(newUrl)){
		return `${protocol}${newUrl}`;
	}
	if(!/^(f|ht)tps?:\/\//i.test(newUrl)){
		return `${protocol}://${newUrl}`;
	}

	return newUrl;
};

export const validateEmail = (email) => {
	if (email == null || email == undefined || email == false) return false;
	//BadCharacters
	const check_email = email.toLowerCase();
	let tmp_email = check_email;
	var specialChars = "áéíóúàèìòùäëïöüâêîôûñçºª";
	for (var i = 0; i < specialChars.length; i++) {
		let letter_to_replace = specialChars.substr(i,1);
		tmp_email = tmp_email.replace(letter_to_replace, "");
	}

	//Expreg
	var re = /^(([^<>()[\]\\,;:\s@\"]+(\.[^<>()[\]\\,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return (re.test(email) && tmp_email.length == email.length) ? true : false;
}

export const validateIPAddress = (ip, version = '4') => {
	if (ip == null || ip == undefined) return false;
	
	// Define a regular expression pattern for IPv4 addresses
	var ipv4Pattern = /^(\d{1,3}\.){3}\d{1,3}$/;

	// Define a regular expression pattern for IPv6 addresses
	var ipv6Pattern = /^([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}$/;

	if (version == '4' && ipv4Pattern.test(ip)) {
		// Check if it's a valid IPv4 address
		var parts = ip.split('.');
		for (var i = 0; i < parts.length; i++) {
			var num = parseInt(parts[i], 10);
			if (num < 0 || num > 255 || isNaN(num)) {
				return false;
			}
		}
		return true;
	} else if (version == '6' && ipv6Pattern.test(ip)) {
		// Check if it's a valid IPv6 address
		return true;
	}
	
	// Not a valid IP address
	return false;
}

export const accentFold = (string) => {
	var accentMap = {
		'à': 'a', 'á': 'a', 'â': 'a', 'ã': 'a', 'ä': 'a', 'å': 'a', // a
		'ç': 'c',                                                   // c
		'è': 'e', 'é': 'e', 'ê': 'e', 'ë': 'e',                     // e
		'ì': 'i', 'í': 'i', 'î': 'i', 'ï': 'i',                     // i
		'ñ': 'n',                                                   // n
		'ò': 'o', 'ó': 'o', 'ô': 'o', 'õ': 'o', 'ö': 'o', 'ø': 'o', // o
		'ß': 's',                                                   // s
		'ù': 'u', 'ú': 'u', 'û': 'u', 'ü': 'u',                     // u
		'ÿ': 'y'                                                    // y
	};
	return string.split('').map(char => accentMap[char] || char).join('');
}

export const validateDomain = (domain) => {
	if (domain == null || domain == undefined) return false;
	//BadCharacters
	const check_domain = domain.toLowerCase();
	let tmp_domain = check_domain;
	var specialChars = "áéíóúàèìòùäëïöüâêîôûñçºª";
	for (var i = 0; i < specialChars.length; i++) {
		let letter_to_replace = specialChars.substr(i,1);
		tmp_domain = tmp_domain.replace(letter_to_replace, "");
	}

	//Expreg
	var re = /^(?!:\/\/)([a-zA-Z0-9-]+\.){1,}[a-zA-Z]{2,}$/;
	return (re.test(domain) && tmp_domain.length == domain.length) ? true : false;
};

export const validateDomainOrEmail = (str) => {
	if(validateEmail(str)) return true;
	if(validateDomain(str)) return true;
	return false;
};

export const validateImageURL = (str) => {
	var pattern = new RegExp('^((https?:)?\\/\\/)?'+ // protocol
		'((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
		'((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
		'(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
		'\\.(jpg|jpeg|png|gif|bmp|webp)$','i'); // image extension
	if (!pattern.test(str)) {
		return false;
	} else {
		return true;
	}
};

export const getSoundPropsById = (file, extra = {}, is_react = false) => {
	const audio_files_path = ((window?.server_type ?? '1') == '0') ? `//wlcdn.cstmapp.com/sounds/` : `/sounds/`;

	if(file == undefined || file == 'none') return {};

	const extra_props = { };
	if(['scratch', 'bubbles'].includes(file)) {
		extra_props.loop = true;
	}

	const audio_src = `${audio_files_path}${file}.mp3?v=1.1`;

	return {
		...extra_props,
		...extra,
		src:(is_react) ? audio_src : [audio_src],
	};
};

export const NSchange = (po, d, value, inmmutable) => {
	if(!Array.isArray(d)) {
		if(d.indexOf('.') == -1) {
			if(value != undefined) po[d] = value;

			if(inmmutable != undefined && inmmutable) return {...po};
			return po[d];
		}

		d = d.split('.');
	}

	//If the object provided does not have the first key we just create an object there
	if(!po[d[0]] && (d.length > 1 && value != undefined)) po[d[0]] = {};

	if (value == undefined && po[d[0]] == undefined) return "";

	if(Array.isArray(po[d[0]]) && po[d[0]].length == 0) po[d[0]] = {};

	//Get the first obj
	if(inmmutable != undefined) {
		var v = {...po[d[0]]};
		po[d[0]] = v;
	} else {
		var v = po[d[0]];
	}

	//For every namespace beyond first one until the end
	for(var i = 1; i < (d.length-1); i++) {
		//Not defined? Create an object
		if(v[d[i]] == undefined) v[d[i]] = {};

		v[d[i]] = {...v[d[i]]};

		//Refer to the object
		v = v[d[i]];
	}

	if(value == undefined && d.length > 1 && (v == undefined || v[d[i]] == undefined)) return "";

	if(value != undefined) {
		v[d[d.length-1]] = value;

		if(inmmutable) {
			var b = {...po};
			return b;
		}
	}

	if(typeof v !== 'object' || v == null) return v;

	if(v[d[d.length-1]] != undefined) return v[d[d.length-1]];

	return v;
};

/**
 * Compute a deep diff of two objects flattening structure
 */
export const deepDiff = (diffs, old, nw, flatten, path) => {
	if(path == undefined) path = '';

	for(var i in old) {
		if(typeof old[i] !== 'string' && typeof old[i] !== 'boolean') {
			var p = i + ".";
			var deep = deepDiff({}, old[i], nw[i], flatten);
			for(var j in deep) diffs[p + j] = deep[j];
		} else {
			if(old[i] != nw[i]) {
				diffs[path+i] = {
					o:old[i],
					n:nw[i]
				};
			}
		}
	}

	return diffs;
}

export const ensureBoolean = (value) => {
	if(value == undefined) return false;
	if(typeof value == 'string') value = (value == 'true' || value == '1') ? true : false;
	if(typeof value == 'number') value = (value == 1) ? true : false;
	return value;
};

export const degToRad = (deg) => {
	return Math.PI * deg / 180;
};

export const radToDeg = (rad) => {
	return 180 * rad / Math.PI;
};

export const parseVideo = (url) => {
	// - Supported YouTube URL formats:
	//   - http://www.youtube.com/watch?v=My2FRPA3Gf8
	//   - http://youtu.be/My2FRPA3Gf8
	//   - https://youtube.googleapis.com/v/My2FRPA3Gf8
	// - Supported Vimeo URL formats:
	//   - http://vimeo.com/25451551
	//   - http://player.vimeo.com/video/25451551
	// - Also supports relative URLs:
	//   - //player.vimeo.com/video/25451551
	if(!url) return { };

	url.match(/(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(shorts\/|video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/);

	var video_id = RegExp.$6;
	if(RegExp.$3.indexOf('youtu') > -1) {
		var platform = 'youtube';
		var video_url = `https://www.youtube.com/embed/${video_id}`;
		var thumbnail_url = `https://img.youtube.com/vi/${video_id}/hqdefault.jpg`;
		var url_info = '&showinfo=0&controls=0&rel=0';

		var r = url.match(/t=(.*?)s\&?/);
		var e = url.match(/e=(.*)s/);

		if(r && r[1] != undefined) url_info += `&start=${r[1]}`;	// start time parameter
		if(e && e[1] != undefined) url_info += `&end=${e[1]}`;		// end time parameter
	} else if(RegExp.$3.indexOf('vimeo') > -1) {
		var platform = 'vimeo';
		var video_url = `https://player.vimeo.com/video/${video_id}`;
		var thumbnail_url = '/img/video_pre-thumb.jpg';
		var url_info = '';
	}

	return {
		type:platform,
		video_id:video_id,
		url:video_url,
		full_url:video_url,
		image:thumbnail_url,

		id:video_id,
		platform:platform,
		video_url:video_url,
		thumbnail_url:thumbnail_url,
		url_info:url_info
	};
};

export const mixedOperators = [
	{k:'<',v:"Less than"},
	{k:'<=',v:"Equal to or less than"},
	{k:'=',v:"Equal to"},
	{k:'>=',v:"Equal to or greater than"},
	{k:'>',v:"Greater than"},
	{k:'<>',v:"Different from"},
	{k:'like',v:"Contains"},
	{k:'^',v:"Starts with"},
	{k:'REGEX',v:"Regular expression"}
];

export const postionOperators = [
	{k:'every',v:"Every"},
	{k:'=',v:"Equal to"},
	{k:'REGEX',v:"Regular expression"},
	{k:'<',v:"Less than"},
	{k:'>',v:"Greater than"},
];

export const numericOperators = [
	{k:'<',v:"Less than"},
	{k:'<=',v:"Equal to or less than"},
	{k:'=',v:"Equal to"},
	{k:'>=',v:"Equal to or greater than"},
	{k:'>',v:"Greater than"},
	{k:'<>',v:"Different from"},
	{k:'REGEX',v:"Regular expression"}
];

export const dateOperators = [
	{k:'<',v:"Less than"},
	{k:'<=',v:"Equal to or less than"},
	{k:'=',v:"Equal to"},
	{k:'>=',v:"Equal to or greater than"},
	{k:'>',v:"Greater than"},
	{k:'BETWEEN',v:"Between"},
	{k:'REGEX',v:"Regular expression"}
];

export const simpleTextOperators = [
	{k:'like',v:"Contains"},
	{k:'not_like',v:"Not Contains"},
	{k:'REGEX',v:"Regular expression"}
];

export const textOperators = [
	{k:'like',v:"Contains"},
	{k:'=',v:"Equal to"},
	{k:'^',v:"Starts with"},
	{k:'REGEX',v:"Regular expression"}
];

export const listOperators = [
	{k:'=',v:"Equal to"},
	{k:'<>',v:"Different from"},
	{k:'REGEX',v:"Regular expression"}
];

export const eqneq = [
	{k:'=',v:"Equal to"},
	{k:'<>',v:"It's not"}
]

export const checkBoxValues = {
	1:"Checked",
	0:"Not checked",
};

export const cssVar = (name, value) => {
	if(name.indexOf('var(') !== -1) name = name.substring(4, name.length - 1);
	if(name[0] != '-') name = `--${name}`; //allow passing with or without --
	if(value) document.documentElement.style.setProperty(name, value);
	return getComputedStyle(document.documentElement).getPropertyValue(name);
};

export const hasMinimumPlan = (min_type = 2) => {
	const best_plan = window?.best_plan ?? false;
	return (best_plan !== false && parseInt(best_plan?.type ?? '0') >= parseInt(min_type)) ? true : false;
};

// WL => 5
export const hasMinimumPlanType = (min_type = 5) => {
	const best_plan = window?.best_plan ?? false;
	return (best_plan !== false && parseInt(best_plan?.planType ?? '0') >= parseInt(min_type)) ? true : false;
};

export const toUTF16 = (codePoint) => {
	var TEN_BITS = parseInt('1111111111', 2);
	function u(codeUnit) {
		return '\\u'+codeUnit.toString(16).toUpperCase();
	}

	if(codePoint <= 0xFFFF) {
		return u(codePoint);
	}
	codePoint -= 0x10000;

	// Shift right to get to most significant 10 bits
	var leadSurrogate = 0xD800 + (codePoint >> 10);

	// Mask to get least significant 10 bits
	var tailSurrogate = 0xDC00 + (codePoint & TEN_BITS);

	return u(leadSurrogate) + u(tailSurrogate);
};

export const removeByRole = (label, roles, action_not_promo_or_giveaway) => {
	const global_roles = (action_not_promo_or_giveaway != undefined) ? action_not_promo_or_giveaway : false;

	if(roles != undefined) {
		if(!global_roles) {
			const actual_role = roles.filter((obj) => { return obj.label_id == label.id})[0];
			if(actual_role) {
				switch(parseInt(actual_role.role)) {
					case agent_roles.ROLE_DESIGNER.id:
						document.querySelectorAll('.not_designer').forEach(element => element.remove());
						break;
					case agent_roles.ROLE_ANALYST.id:
						document.querySelectorAll('.not_analyst').forEach(element => element.remove());
						break;
					case agent_roles.ROLE_BASIC_EDITOR.id:
						document.querySelectorAll('.not_basiceditor').forEach(element => element.remove());
						break;
					case agent_roles.ROLE_EDITOR.id:
						document.querySelectorAll('.not_editor').forEach(element => element.remove());
						break;
					default:
						break;
				}
			}
		} else {
			var is_creator = false;
			roles.map((actual_role) => {
				switch(parseInt(actual_role.role)) {
					case agent_roles.ROLE_ADMIN.id:
					case agent_roles.ROLE_MANAGER.id:
					case agent_roles.ROLE_EDITOR.id:
					case agent_roles.ROLE_BASIC_EDITOR.id:
					case agent_roles.ROLE_DESIGNER.id:
						is_creator = true;
						break;
					default:
						break;
				}
			});
			if(!is_creator)document.querySelectorAll('.not_creator').forEach(element => element.remove());
		}
	}
};

export const removeEmojis = (str) => {
	return str.replace(/([#0-9]\u20E3)|[\xA9\xAE\u203C\u2047-\u2049\u2122\u2139\u3030\u303D\u3297\u3299][\uFE00-\uFEFF]?|[\u2190-\u21FF][\uFE00-\uFEFF]?|[\u2300-\u23FF][\uFE00-\uFEFF]?|[\u2460-\u24FF][\uFE00-\uFEFF]?|[\u25A0-\u25FF][\uFE00-\uFEFF]?|[\u2600-\u27BF][\uFE00-\uFEFF]?|[\u2900-\u297F][\uFE00-\uFEFF]?|[\u2B00-\u2BF0][\uFE00-\uFEFF]?|(?:\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDEFF])[\uFE00-\uFEFF]?/g, '');
};

export const shorten = (str, maxLen, separator = ' ') => {
	if(str.length <= maxLen) return str;
	return str.substr(0, str.lastIndexOf(separator, maxLen));
};

export const shortenEtc = (str, maxLen, separator = ' ') => {
	if(str.length <= maxLen) return str;
	const trimmedStr = str.substr(0, str.lastIndexOf(separator, maxLen));
	return trimmedStr + '...';
};

export const baseFake = (str,force_position) => {

	if(force_position == undefined)force_position=false;

	let long_string= str.length;
	//El mateix array es troba a bootstrap.php i a Utils.php, ULL!
	let strings_to_add = ['nQWYCdpnmjOu','5mtStOA87QlP','1820NfUVEY7w','hu8Kx58rWb9P','CJA82pxxf78Q','s1ujgbvSC7bj','SRWScGGKtK3Y','oeRPOEiBBMvg','mYHmFJpNpzFB','PniNpOPInOUD','DZeJCJXIMCfu','17xqv14mgAyn','QOMg1Nblaxi0','tYpo7fY8GRQU','U0QfKsg0ytXs','TVQeDwIPF4A4','Q9wRjjxHjDa2','QvcTAzzIMbqr','T7OQUuYC1RCW','7NlLHQ4IMBDN','avg6yx3GOLiS','mgECm2BAwA1a','Q6ixe2Zj7YsA','eTi919jLSKNr','MqJ0mTYKsE7k','IdNO0d1M03qL','hMsJgLKehHtX','eFxWIBSX2CoI','FM38i6OGkSbA','fbJc0LoCr2Dt','jpbMMK36yH0q','JJzOWBJUMaoq','npn1okaWnhYo','eYOOXHeZfSEx','5tgy60UusFId','10rtmI8YLDWF','xZDpXfcgxxjo','ICy0mixb5qGK','9xV8NfmPksAu','eY3ZKfYvDrqR','AA8x3VbJLJyW','GGyb2y8LNVzM','BMyKA97kuUxj','iXmfkLTA4KJA','hg8R3t20Qiwy','4whcD1Y2C8AC','9HFoAZda4sBF','JDjWgWEiAXIA','p0D1kHRzhFqr','URksscyslOLf','mVO6aL7Dy450','MmTnPhbv9GHL','azCOem5msLMl','OV4LiGjQWBiH','LzJxvMi4UAI9','iNYCw1a7Oe8h','HmIGkPdyasHo','I0lr74fvpCh9','ewfqKaUN2W18','yHhroJddOf2R','FBsJjwNWfKC3','HGPoFHVhSugt','SFjhRH3LmTSC','86k1AOc8gt7S','Gr8aoKzTmfIV','1I8miP8MZLtR','bUyaGOtCDyJC','exyCxTUrYCuf','3E8HjRn5xvMS','0ckaVKO5dR4g','cg8LHMlktBos','mBXpZ80k1dTY','ftn52GR8ZrCN','NJltA6t4idYq','MCgup1BGWmXz','GvIIsZgvegxv','oAVD6FyVrWWp','Sy7wxMN1bWQm','MysObAABmAp3','c9wZB9q0tYWt','qqbo17iFFY8t','BTf3Lz8JxnYb','nt4MmPrulLwX','CD6aUD9u8sBX','FS2iDDQIK8Wb','m1zwSTKsBB7h','aaxlUoh50IRq','u8iIp0q9qv38','TLYYcVvQ4Kjh','OgbzQOR0QCLh','4YmBMSV9NFBM','vz6ewMOivzEp','O8quwmtvCw3L','nKJlraehLkDr','GkDS0SNZNaQP','jLNF5RadEjWW','qPN5HkhAx7MQ','cVUM5PFGLnCJ','JTt5JVkWKzQ2','iIH89P4nw6mr'];
	let random_number_strings = _random(0,_size(strings_to_add) - 1);
	let position_to_add = _random(0,long_string - 1);
	if(force_position){
		position_to_add = Math.round(long_string - 1 / 2);
		random_number_strings = force_position % strings_to_add.length;
	}
	let result = [_size(random_number_strings.toString()),random_number_strings,str.slice(0, position_to_add), strings_to_add[random_number_strings], str.slice(position_to_add)].join('');
	return result;
};

export const getVerified = (e, urlencode) => {
	if(urlencode == undefined)urlencode = false;
	var Base64={_keyStr:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",encode:function(e){var t="";var n,r,i,s,o,u,a;var f=0;e=Base64._utf8_encode(e);while(f<e.length){n=e.charCodeAt(f++);r=e.charCodeAt(f++);i=e.charCodeAt(f++);s=n>>2;o=(n&3)<<4|r>>4;u=(r&15)<<2|i>>6;a=i&63;if(isNaN(r)){u=a=64}else if(isNaN(i)){a=64}t=t+this._keyStr.charAt(s)+this._keyStr.charAt(o)+this._keyStr.charAt(u)+this._keyStr.charAt(a)}return t},decode:function(e){var t="";var n,r,i;var s,o,u,a;var f=0;e=e.replace(/[^A-Za-z0-9\+\/\=]/g,"");while(f<e.length){s=this._keyStr.indexOf(e.charAt(f++));o=this._keyStr.indexOf(e.charAt(f++));u=this._keyStr.indexOf(e.charAt(f++));a=this._keyStr.indexOf(e.charAt(f++));n=s<<2|o>>4;r=(o&15)<<4|u>>2;i=(u&3)<<6|a;t=t+String.fromCharCode(n);if(u!=64){t=t+String.fromCharCode(r)}if(a!=64){t=t+String.fromCharCode(i)}}t=Base64._utf8_decode(t);return t},_utf8_encode:function(e){e=e.replace(/\r\n/g,"\n");var t="";for(var n=0;n<e.length;n++){var r=e.charCodeAt(n);if(r<128){t+=String.fromCharCode(r)}else if(r>127&&r<2048){t+=String.fromCharCode(r>>6|192);t+=String.fromCharCode(r&63|128)}else{t+=String.fromCharCode(r>>12|224);t+=String.fromCharCode(r>>6&63|128);t+=String.fromCharCode(r&63|128)}}return t},_utf8_decode:function(e){var t="";var n=0;var r=c1=c2=0;while(n<e.length){r=e.charCodeAt(n);if(r<128){t+=String.fromCharCode(r);n++}else if(r>191&&r<224){c2=e.charCodeAt(n+1);t+=String.fromCharCode((r&31)<<6|c2&63);n+=2}else{c2=e.charCodeAt(n+1);c3=e.charCodeAt(n+2);t+=String.fromCharCode((r&15)<<12|(c2&63)<<6|c3&63);n+=3}}return t}}
	var string = JSON.stringify(e);
	var encodedString = string;
	if(urlencode)encodedString = encodeURIComponent(encodedString);//Pels EMOJIS
	encodedString = Base64.encode(encodedString);
	return encodedString;
};

export const encodeBase64Fake = (obj, urlencode, force_position) => {
	return baseFake(getVerified(obj, urlencode),force_position);
};

export const cleanString = (input) => {
	let output = "";
	for(let i = 0; i < input.length; i++) {
		if(input.charCodeAt(i) <= 127) output += input.charAt(i);
	}

	output = output.replace(/(^[\s\u200b]*|[\s\u200b]*$)/g, '')
	output = output.replace(/(^[\s\u200c]*|[\s\u200c]*$)/g, '')
	output = output.replace(/(^[\s\u200d]*|[\s\u200d]*$)/g, '')
	output = output.replace(/[\u200B-\u200D\uFEFF]/g, '');
	let re = "\u2028|\u2029";
	output = output.replace(re, "");
	let re2 = /(?![\x00-\x7F]|[\xC0-\xDF][\x80-\xBF]|[\xE0-\xEF][\x80-\xBF]{2}|[\xF0-\xF7][\x80-\xBF]{3})./g;
	output = output.replace(re2, "");
	output = output.toString();

	return output;
};

export const ensureAlfanumericCharacter = (char) => {
	const permitted_chars = /^[\u00BF-\u1FFF\u2C00-\uD7FF\w]$/;
	const is_permitted_char = permitted_chars.test(char);

	const non_permitted_chars = /^[\u005F]$/;
	const is_non_permitted_char = non_permitted_chars.test(char);

	return (is_permitted_char && !is_non_permitted_char) ? true : false;
};

export const removeAccents = (v) => {
	// remove accents and set to lowercase:
	return v.normalize("NFD").toLowerCase().replace(/\p{Diacritic}/gu, "");
};

export const cleanRef = (v) => {
	v = removeAccents(v);

	// replace spaces with "_" (except those at beginning and end, which are removed):
	v = v.trim().replace(/\s/gu, "_");

	// replace all non alphanumeric or underscore or hiphen characters with "_":
	v = v.replace(/\W/gu, "_");

	// replace double underscores with "_":
	v = v.replace(/_+/gu, "_");

	return v;
};

export const ErrorLog = (target_id, type, data, description) => {
	var send_data = {};
	send_data.target_id = target_id != undefined ? target_id : null;
	send_data.type = type != undefined ? type : null;
	send_data.data = data != undefined ? data : null;
	send_data.description = description != undefined ? description : null;
	$.post('/utils/errorlog', send_data);
};

export const shuffleArray = (a) => {
	var j, x, i;
	for(i = a.length - 1; i > 0; i--) {
		j = Math.floor(Math.random() * (i + 1));
		x = a[i];
		a[i] = a[j];
		a[j] = x;
	}
	return a;
};

export const inArray = (needle, haystack) => {
	let length = haystack.length;

	for(var i = 0; i < length; i++) {
		if(typeof haystack[i] == 'object') {
			if(arrayCompare(haystack[i], needle)) return true;
		} else {
			if(haystack[i] == needle) return true;
		}
	}
	return false;
};

export const isArray = (element) => {
		return Object.prototype.toString.call(element) === '[object Array]';
};

export const isBase64 = (string) => {
	var base64regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
	return base64regex.test(string);
};

export const shortName = (string) => {
	return string.toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^-+|-+$/g, "_").replace(/^-+|-+$/g, '');
};

export const stripTags = (str, replace_br = false) => {
	if(str == "") return str;

	let str_ok = str;
	if(replace_br) {
		str_ok = str_ok.replace(/(<br\/>)/gi, " ");
		str_ok = str_ok.replace(/(<br>)/gi, " ");
		str_ok = str_ok.replace(/(<br \/>)/gi, " ");
	}
	return str_ok.replace(/(<([^>]+)>)/gi, "");
};

export const calculateSliceSize = (radius, num_slices) => {
	const slice_angle = 360 / num_slices;
	const slice_image_h = radius;
	const h_padding = 10;
	const slice_image_w = Math.floor(2 * radius * Math.cos(Math.PI * (90 - slice_angle / 2) / 180)) + h_padding;
	return { width:slice_image_w, height:slice_image_h, angle:slice_angle };
};

const sortMatches = (matches) => {
	return matches.sort((x, y) => {
		if(x.id > y.id) return -1;
		if(x.id < y.id) return 1;
		return 0;
	});
}

export const importCSS = (file) => {
	const doc = document.getElementById(file);
	if(doc) return;

	let link = document.createElement('link');
	link.id = file;

	link.href = `${window.cdn_react_url}css/${file}?v=${window.cdn_version}`;
	link.rel = 'stylesheet';

	document.head.appendChild(link);
};

export const detectIfBracketHasImages = (teams) => {
	let has_images = 0;
	let has_bg_images = 0;
	let has_bg_colors = 0;

	teams.map((team, t) => {
		if(team.image != undefined && team.image != "") has_images++;
		if(team.background != undefined && team.background != "") has_bg_images++;
		if(team.color != undefined && team.color != "") has_bg_colors++;
	})

	return { images:has_images, bg_images:has_bg_images, bg_color:has_bg_colors };
};

export const scoresToBracket = (matches, num_rounds, current_round) => {
	let scores = {};
	let sorted_matches = sortMatches(matches);

	let round = num_rounds;

	let num_match = 1;
	sorted_matches.map((_match, m) => {
		let match = _match.BracketMatch;

		let match_round = (num_rounds - round) + 1;
		let _candidateA = (typeof match.candidateA == 'object') ? match.candidateA.id : match.candidateA;
		let _candidateB = (typeof match.candidateB == 'object') ? match.candidateB.id : match.candidateB;

		scores[`${match_round}_${_candidateA}_${_candidateB}`] = {
			round:(num_rounds - round) + 1,
			votes:[match.votesA, match.votesB],
			score:[match.scoreA, match.scoreB],
			teams:[_candidateA, _candidateB],
			winner:match.winner,
			id:match.id,
		};

		if(num_match > Math.pow(2, round - 1) - 1) {
			round--;
			num_match = 1;
		} else {
			num_match++;
		}
	});

	return scores;
};

export const displayPromoHeader = (promotion) => {
	const display_layout_props = promotion?.layout_props?.header?.display ?? null;
	if(display_layout_props != undefined) return ensureBoolean(display_layout_props);

	if(promotion?.config?.custom_menu == undefined) return true;

	const show_menu = ((promotion?.config?.custom_menu?.status ?? '1') == '1') ? true : false;
	const hide_header = window?.hide_header ?? false;

	return (show_menu && !hide_header) ? true : false;
};

export const removeHTMLTags = (text) => {
	if((text === null) || (text === "")) return false;

	text = text.toString();

	return text.replace(/(<([^>]+)>)/ig, '');
};

export const isFooterOn = (promotion) => {
	const is_wl = (promotion.promo_type == '2') ? true : false;
	if(!is_wl) return true;
	
	const display_layout_props = promotion?.layout_props?.footer?.display ?? null;
	if(display_layout_props != undefined) return display_layout_props;

	const display_footer = promotion?.display_footer ?? true;
	if(display_footer != undefined) return display_footer;

	const footer_props = promotion?.config?.footer ?? {};
	return promotion?.display_footer ?? (((footer_props?.display_footer ?? '1') == '1') ? true : false);
};

export const displayPromoFooter = (promotion, total_locs) => {
	const display_footer = isFooterOn(promotion);

	const footer_props = promotion?.config?.footer ?? {};
	const is_wl = (promotion.promo_type == '2') ? true : false;

	const display_powered = (isNotEmpty(promotion, 'powered')) ? true : false;

	const _display_toc = footer_props?.display_toc ?? '0';
	let display_toc = (_display_toc != '0' && _display_toc != 'false' && _display_toc !== false) ? true : false;
	if(!isNotEmpty(promotion, 'toc') && !isNotEmpty(promotion, 'external_toc_url')) display_toc = false;
	
	const _display_policy = footer_props?.display_policy ?? '0';
	let display_policy = (_display_policy != '0' && _display_policy != 'false' && _display_policy !== false) ? true : false;
	if(!isNotEmpty(promotion, 'policy') && !isNotEmpty(promotion, 'external_policy_url')) display_policy = false;
	
	const has_sponsors = ((promotion?.layout_props?.footer?.sponsors_image ?? '0') != '0') ? true : false;
	
	const _display_cookies = footer_props?.display_cookies ?? '0';
	let display_cookies = (_display_cookies != '0' && _display_cookies != 'false' && _display_cookies !== false) ? true : false;
	if(!isNotEmpty(promotion.config, 'cookies_policy') || promotion.config.cookies_policy == 0) display_cookies = false;

	const display_langs = (is_wl && total_locs > 1) ? true : false;

	const hide_footer = (!display_footer || (is_wl && !has_sponsors && !display_powered && !display_toc && !display_policy && !display_cookies && !display_langs)) ? true : false;

	return { hide_footer, display_powered, display_toc, display_policy, display_cookies, display_langs };
};

export const humanizeTime = (time_in_seconds, i18n) => {
	let seconds = time_in_seconds;

	const seconds_in_minute	= 60;
	const seconds_in_hour	= seconds_in_minute * 60;
	const seconds_in_day	= seconds_in_hour * 24;
	const seconds_in_week	= seconds_in_day * 7;
	const seconds_in_month	= seconds_in_week * 30;
	const seconds_in_year	= seconds_in_month * 12;

	const years = Math.max(0, Math.floor(seconds / seconds_in_year));
	seconds %= seconds_in_year;

	const months = Math.max(0, Math.floor(seconds / seconds_in_month));
	seconds %= seconds_in_month;

	const weeks = Math.max(0, Math.floor(seconds / seconds_in_week));
	seconds %= seconds_in_week;

	const days = Math.max(0, Math.floor(seconds / seconds_in_day));
	seconds %= seconds_in_day;

	const hours = Math.max(0, Math.floor(seconds / seconds_in_hour));
	seconds %= seconds_in_hour;

	const minutes = Math.max(0, Math.floor(seconds / seconds_in_minute));
	seconds %= seconds_in_minute;

	function plural(count, singular) {
		if(count < 1) return "";
		return ` ${count} ${i18n((count < 2) ? singular : `${singular}s`)}`;
	}

	return plural(years, "year") + plural(months, "month") + plural(weeks, "week") + plural(days, "day") + plural(hours, "hour") + plural(minutes, "minute") + plural(seconds, "second");
};

const verifyRoles = (roles,tasks,cb) => {
	var default_roles = [];
	default_roles['Admin'] = ["ANALYZE", "ADVERTISE", "MODERATE", "CREATE_CONTENT", "MANAGE"];
	default_roles['Advertiser'] = ["ANALYZE", "ADVERTISE"];
	default_roles['Analyst'] = ["ANALYZE"];
	default_roles['Editor'] = ["ANALYZE", "ADVERTISE", "MODERATE", "CREATE_CONTENT"];
	default_roles['Moderator'] = ["ANALYZE", "ADVERTISE", "MODERATE"];
	let res = false;
	roles.map((item_role) => {
		let tasks_done = 0;
		default_roles[item_role].map((set_role) => {
			let position = tasks.indexOf(set_role);
			if(position != -1) tasks_done++;
		});
		if(default_roles[item_role].length == tasks_done) {
			res = true;
		}
	});
	return res;
}


export const checkRoleFB = (page_id, roles, pagination, cb) => {
	var page_found = false;
	let roles_verified = false;
	var bool = false;
	var url = '/me/accounts?fields=name,id,tasks,access_token,has_transitioned_to_new_page_experience';
	url = (pagination) ? url + '&after=' + pagination : url;
	FB.api(url, (response) => {
		if(response.data !== undefined && response.data.length > 0) {
			$.each(response.data, (i, item) => {
				if(item.id == page_id){
					page_found = true;
					if(item.has_transitioned_to_new_page_experience){
						FB.api(page_id+'/roles?access_token='+item.access_token, (response2) => {
							if(response2.data && response2.data.length >0){
								roles_verified = verifyRoles(roles,response2.data[0].tasks,cb);
								bool = roles_verified ?? false;
								cb(bool,response);
							}
						});
					}else{
						roles_verified = verifyRoles(roles,item.tasks,cb);
						bool = roles_verified ?? false;
						cb(bool,response);
					}
				}
			});
			if(!page_found && response.paging.next != undefined) checkRoleFB(page_id,roles,response.paging.cursors.after,cb);
		} else {
			//FB Error, assume role correctly
			cb(true,response);
		}
	});

	//var url = (next == undefined)? '/me/accounts?fields=name,id,username,global_brand_root_id,link&limit=50':next;
};

/*
export const checkRoleFB_old = (page_id, roles, pagination, cb) => {
	var default_roles = [];
	default_roles['Admin'] = ["ANALYZE", "ADVERTISE", "MODERATE", "CREATE_CONTENT", "MANAGE"];
	default_roles['Advertiser'] = ["ANALYZE", "ADVERTISE"];
	default_roles['Analyst'] = ["ANALYZE"];
	default_roles['Editor'] = ["ANALYZE", "ADVERTISE", "MODERATE", "CREATE_CONTENT"];
	default_roles['Moderator'] = ["ANALYZE", "ADVERTISE", "MODERATE"];

	var page_found = false;
	var bool = false;
	var url = '/me/accounts?fields=name,id,tasks,access_token,has_transitioned_to_new_page_experience';
	url = (pagination) ? url + '&after=' + pagination : url;
	FB.api(url, (response) => {
		if(response.data !== undefined && response.data.length > 0) {
			$.each(response.data, (i, item) => {
				if(item.id == page_id){
					page_found = true;
					roles.map((item_role) => {
						let tasks_done = 0;
						default_roles[item_role].map((set_role) => {
							let position = (item.tasks).indexOf(set_role);
							if(position != -1) tasks_done++;
						});

						if(default_roles[item_role].length == tasks_done) {
							bool = true;
							return;
						}
					});
				}
			});
			if(!page_found && response.paging.next != undefined) checkRoleFB(page_id,roles,response.paging.cursors.after,cb);
		} else {
			//FB Error, assume role correctly
			bool = true;
		}
		cb(bool,response);
	});

	//var url = (next == undefined)? '/me/accounts?fields=name,id,username,global_brand_root_id,link&limit=50':next;
};*/

export const cleanFieldProps = (field_props) => {
	let wrapper_props = {...field_props};
	wrapper_props.label = field_props.children;
	wrapper_props.children = null;
	wrapper_props.style = null;
	wrapper_props.zoomable = null;
	return wrapper_props;
};

export const setupStageTypography = (type, layout_props) => {
	let typography;
	let typography_weight;
	if(layout_props == undefined) layout_props = {};

	switch(type) {
		case 'main':
			if(layout_props.main_font != undefined) typography = parseFontName(layout_props.main_font);
			typography_weight = layout_props?.main_font_roman ?? '500';
			break;

		case 'secondary':
		default:
			if(layout_props.secondary_font != undefined) typography = parseFontName(layout_props.secondary_font);
			typography_weight = layout_props?.secondary_font_roman ?? '500';
			//if(layout_props.secondaryfontWeightRoman != undefined) typography_weight = layout_props.secondaryfontWeightRoman;
			break;

		case 'generic':
			typography = parseFontName("Arial");
			typography_weight = "500";
			break;
	}

	return { typography, typography_weight };
}

export const getNumTries = (num, size) => {
	if (size == undefined) return [];
	switch(num) {
		case '1':
			return [1, 2, 3, 4].filter((e) => { return (e < size); }).map((e) => ({ k:e, v:e }));

		case '3':
			const num_tries = parseInt(size) + 2;
			const options = [];
			for (var i =  3 ; i <=  num_tries; i++) {
				options.push(
					{ k:i, v:i }
				)
			}
			return options;
			//[{ k:num_tries, v:num_tries }];
	}
};


/* KONVAJS CUSTOM FUNCTIONS - ini */
export const tweenAnimation = (refs, item_ref, final_state, cb, duration, delay, easing) => {
	if(refs.current[item_ref] == undefined) {
		if(cb != undefined) cb();
		return;
	}

	if(duration == undefined) duration = 1;
	if(delay == undefined) delay = 0;
	if(easing == undefined) easing = Konva.Easings.StrongEaseInOut;

	setTimeout(() => {
		refs.current[item_ref].to({ ...final_state, duration, easing, onFinish:cb });
	}, delay * 1000);
};

export const loadKonvaImage = (image, cb) => {
	let img = new window.Image();
	img.crossOrigin = 'Anonymous';
	img.src = image;
	img.onload = cb;
	return img;
};

export const loadImage = (image, cb) => {

	
	let img = new window.Image();
	const onload_cb = (e) => {
		cb(img);
	}
	img.crossOrigin = 'Anonymous';
	img.src = image;
	img.onload = onload_cb;
	return img;
};

export const getPreferredDarkColorScheme = () => {
	return (window.matchMedia && window.matchMedia('(prefers-color-scheme:dark)').matches) ? true : false;
};

export const detectPreferredDarkColorSchemeChanges = (cb) => {
	window.matchMedia('(prefers-color-scheme:dark)').addEventListener('change', (event) => {
		if(cb != undefined) cb(event.matches);
	});
};

export const getImageSizeToFit = (max_w, max_h, img) => {
	return Math.min(max_w, max_h) / (Math.min(img.image_w, img.image_h));
};

export const minutesToNextHour = (next_participation) => {
	let hours = Math.abs(EPDateDiff(null, next_participation) / 3600000);
	let duration = (hours - Math.floor(hours)) * 3600000;
	return EPDateHumanize(EPDateDuration(duration));
}

export const is_json = (text) => {
	if (typeof str === 'string' && /^[\],:{}\s]*$/.test(text.replace(/\\["\\\/bfnrtu]/g, '@').
		replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').
		replace(/(?:^|:|,)(?:\s*\[)+/g, ''))) {
		return true;
	}else{
		return false;
	}
}

export const loadKonvaFont = (font_name, cb) => {
	let isFontLoaded = false;

	const font_canvas = document.createElement('canvas');
	const ctx = font_canvas.getContext('2d');
	ctx.font = `normal 20px ${font_name}`;

	const TEXT_TEXT = "Some test text";
	const initialWidth = ctx.measureText(TEXT_TEXT).width;

	const whenFontIsLoaded = (cb, attemptCount) => {
		if(attemptCount === undefined) attemptCount = 0;

		if(attemptCount >= 20 || isFontLoaded) {
			cb();
			return;
		}

		const width = ctx.measureText(TEXT_TEXT).width;
		if(width !== initialWidth) {
			//setTimeout(() => {
				// An extra delay of 500ms to ensure the complete loading of everything so elements don't get wrongly positioned in the stage.
				// This delay will only apply if the number of loading attemps was lower than 8 (otherwise, the loading time has been already big enough).
				// NOTE: If it's still happening, this timeout can be removed because it means it comes from another place.
				printToConsole("FONT LOADED NOW!", width, initialWidth);
				isFontLoaded = true;
				cb();
				return;
			//}, (attemptCount < 8) ? 500 : 0);
		}

		setTimeout(() => {
			printToConsole("FONT LOADED TRY " + attemptCount, width, initialWidth);
			whenFontIsLoaded(cb, attemptCount + 1);
		}, 150);
	};

	printToConsole("FONT LOADED INIT");

	whenFontIsLoaded(cb, 0);
};

export const checkIfLetterIsValid = (letter,symbols = false) => {
	if(letter == undefined || letter == "" || letter == " ") return false;

	if(symbols){
		const special_chars = ['\'', '!', '¡', '@', '#', '$', '€', '¥', '£', '%', '&', '*', '(', ')', '-', '_', '+', '=', '{', '}', '[', ']', ';', ':', '<', '>', ',', '.', '·', ';', '/', '?', '¿', 'ª', 'º'];
		const is_symbol = special_chars.indexOf(letter)>-1;
		if(is_symbol)return true;
	}

	return /^([a-zA-Z0-9\u00C0-\u00FF]+)$/.test(letter) ||
	/^[\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]$/.test(letter);
};

export const detectIfTextIsRTL = (text) => {
	return (/[\u0591-\u07FF]/.test(text)) ? true : false;
}

// Return a new array that is a deranged version of arr
// Guarantee that no member retains its original position
export const _derange = (arr) => {
	// Make a copy of arr
	var c = arr.slice();
	// If arr.length is < 2, return copy
	if (c.length < 2) return c;

	var result = [];
	var idx, i, iLen;

	// Keep track of whether last member has been moved
	var lastMoved = false;

	// Randomly remove a member of c, with conditions...
	for(i=0, iLen=c.length - 1; i<iLen; i++) {
		// If get down to final two and last hasn't been moved,
		// swap last two and append to result
		if(c.length == 2 && !lastMoved) {
			result = result.concat(c.reverse().splice(0, 2));
			break;
		}

		let control_break = 100;
		// Otherwise, select a remaining member of c
		do {
			idx = Math.random() * c.length | 0;
			// But make sure it's not going back in the same place
			control_break--
		} while ((arr.indexOf(c[idx]) == result.length || c[idx] == arr[result.length]) && control_break > 0);
		//Comparem posicio i VALOR!!! podria ser que una lletra igual en diferent posicio coincidis

		// Add member to result
		result.push(c.splice(idx, 1)[0]);

		// Remember if last was just moved
		lastMoved = lastMoved || idx == c.length;
	}

	// Add the last member, saves a do..while iteration about half the time
	if(c.length) result.push(c[0]);
	return result;
}
/* KONVAJS CUSTOM FUNCTIONS - end */

export const checkIfPromoHasRankingEnablable = (promo) => {
	const has_ranking = (window.actual_promotion_type.has_ranking != '0') ? true : false;
	const gallery_active = (promo.public_entries) ? true : false;
	const nonbasic = (promo.promo_type > 0) ? true : false;
	const has_login_enabled = window?.login_enabled ?? false;
	const is_multiparticipation = promo?.multi_participation ?? false;
	const login_active = (has_login_enabled && (window.force_login || is_multiparticipation)) ? true : false;

	let is_enabled = false;
	if(has_ranking) is_enabled =  true;
	if(isNotEmpty(promo, 'need_photo')) is_enabled =  true;
	if(isNotEmpty(promo, 'need_video')) is_enabled =  true;
	if(isNotEmpty(promo, 'need_comments')) is_enabled =  true;
	
	// public_recruits
	if(promo.public_recruits != undefined && promo.public_recruits != "0") is_enabled =  true;
	
	// promo_refer_a_friend
	if(promo.promotion_type_id == '14') is_enabled =  true;
	
	if(!nonbasic && !gallery_active) is_enabled = false;
	if(!login_active && has_ranking) is_enabled = false;

	return is_enabled;
};

export const integrationConnect = (social, saveToken) => {
	return (e, cb) => {
		let popup = window.open('', '_blank', "width=500,height=400,scrollbars=no");
		$.get(`/utils/social/${social}?backend`, (resp) => {
			if(resp.status == 0) {
				popup.location.href = resp.url;
				$(window).on("focus", (event) => {
					$.get(`/utils/social/${social}?backend`, (resp2) => {
						if(resp2.status === 1) {
							saveToken(resp2.connection_id,cb);
							return;
						}
						
						if(cb != undefined) cb();
					}, 'JSON');
					$(window).off('focus');
				});
			}

			if(resp.status == 1) {
				popup.close();
				if (resp.connection_id != undefined) {
					saveToken(resp.connection_id,cb);
					return;
				}
				saveToken(resp.api_key,cb);
			}
		}, 'JSON');
	}
};

export const wrapWithTag = (text, tag, avoid_tags = ['h1', 'h2', 'h3', 'p']) => {
	let apply = true;
	if(avoid_tags.length > 0) {
		avoid_tags.map((avoid) => {
			if(text.indexOf(`<${avoid}`) !== -1) apply = false;
		});
	}

	if(!apply) return text;

	return `<${tag}>${text}</${tag}>`;
};

export const parseBool = (v) => {
	return (v == true || v == 'true');
};

export const getBackgroundImageURL = (promotion) => {
	const bg_image = promotion?.config?.promotion_default_bkg ?? false;

	const bg_image_url = (isNotEmpty(promotion.layout_props.background, 'background_image')) ? promotion.layout_props.background.background_image : false;

	// JUST UPLOADED CUSTOM IMAGE:
	if(bg_image == 'custom' && isBase64(bg_image_url)) return { url:promotion.bg_image_tab };

	// CUSTOM IMAGE FROM DATABASE:
	if(bg_image_url !== false) return { url:promotion.layout_props.background.full_background_image };

	// CUSTOM ERASED IMAGE FROM DATABASE:
	if(bg_image == 'custom' && bg_image_url === false) return false;

	// PRESET IMAGE:
	if(bg_image != '') {
		let bg_image_preset = false;
		switch(bg_image) {
			case '2.jpg':
			case '6.jpg':
			case '7.jpg':
				bg_image_preset = bg_image.replace('.jpg', '_full.png');
				break;

			//case '3.jpg':
			//case '4.jpg':
			case '5.jpg':
				bg_image_preset = bg_image.replace('.jpg', '_full.jpg');
				break;
			
			default:
				bg_image_preset = bg_image;
		}

		return { url:`${window.static_domain_1}img/backgrounds/${bg_image_preset}`, is_preset:true };
	}

	return false;
};

export const RGB_2_ARRAY = (rgb) => {
	if(rgb.indexOf("#") != -1) return colorHEX2RGB(rgb);

	rgb = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
	return [rgb[1], rgb[2], rgb[3], 1];
};

export const lightenMainColorByPercent = (percent, color) => {
	if(color == undefined) {
		color = main_color;
	} else if(typeof(color) == 'string') {
		color = RGB_2_ARRAY(color);
	}

	return RGB_2_HEX(shadeRGBColorByPercent(color, percent, false));
};

export const darkenMainColorByPercent = (percent, color) => {
	if(color == undefined) {
		color = main_color;
	} else if(typeof(color) == 'string') {
		color = RGB_2_ARRAY(color);
	}

	return RGB_2_HEX(shadeRGBColorByPercent(color, -percent, false));
};

export const shadeRGBColorByPercent = (color, percent, return_as_array) => {
	if(return_as_array == undefined) return_as_array = false;

	var t = (percent < 0) ? 0 : 255,
		p = (percent < 0) ? percent * -1 : percent,
		R = parseInt(color[0]),
		G = parseInt(color[1]),
		B = parseInt(color[2]);

	var end_R = Math.round((t - R) * p) + R;
	var end_G = Math.round((t - G) * p) + G;
	var end_B = Math.round((t - B) * p) + B;

	if(return_as_array) {
		return [end_R, end_G, end_B, 1];
	} else {
		return 'rgba(' + (end_R) + ', ' + (end_G) + ', ' + (end_B) + ', 1)';
	}
};

export function getLayoutStage(stage, promo_layout_props) {
	const base = {
		color:{
			main_color:null,				// promo_layout_props.color.main_color
			main_color_variant:null,		// promo_layout_props.color.main_color variation
			text_color:null,				// light or dark from color.main_color
			bar_color:null,					// stage.color_question_ko
		},
		button:{
			background_color:null,			// promo_layout_props.button.background_color
			color:null,						// promo_layout_props.button.color
			background_color_hover:null,	// promo_layout_props.button.background_color_hover
			color_hover:null,				// promo_layout_props.button.color_hover
		},
		text:{
			font_family:'secondary',
			font_weight:'roman',
			text_color:null,				// promo_layout_props.text.text_color
			font_size:1,
			line_height:1.2,
		},
	};

	const final = deepMerge(base, stage?.layout_props ?? {});

	// COLOR
	applyValueNotNull(final.color, 'main_color', base, () => {
		return promo_layout_props.color.main_color;
	});
	applyValueNotNull(final.color, 'main_color_variant', base, () => {
		return (isColorBright(final.color.main_color)) ? darkenMainColorByPercent(0.3, final.color.main_color) : lightenMainColorByPercent(0.3, final.color.main_color);
	});
	applyValueNotNull(final.color, 'text_color', base, () => {
		return (isColorBright(final.color.main_color)) ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)';
	});
	applyValueNotNull(final.color, 'bar_color', base, () => {
		return stage?.color_question_ko ?? 'rgba(215, 35, 60, 1)';
	});

	// BUTTON
	applyValueNotNull(final.button, 'background_color', base, () => {
		return promo_layout_props.button.background_color;
	});
	applyValueNotNull(final.button, 'color', base, () => {
		return promo_layout_props.button.color;
	});
	applyValueNotNull(final.button, 'background_color_hover', base, () => {
		return promo_layout_props.button.background_color_hover;
	});
	applyValueNotNull(final.button, 'color_hover', base, () => {
		return promo_layout_props.button.color_hover;
	});

	// TEXT
	applyValueNotNull(final.text, 'text_color', base, () => {
		return (isColorBright(final.color.main_color)) ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)';
	});

	return final;
};

export function getLayoutQuiz(stage, promo_layout_props) {
	const base = {
		question:{
			force_align_center:false,
		},
		answer:{
			font_weight:'roman',
			color:null,
			background_color:null,
			border_color:null,
			border_width:null,
			color_hover:null,
			background_color_hover:null,
			border_color_hover:null,
			tick_color:null,
			tick_bg_color:null,
			color_selected:null,
			background_color_selected:null,
			border_color_selected:null,
			force_uppercase:false,
		},
		continue:{
			override_styles:false,
			color:null,
			background_color:null,
			color_hover:null,
			background_color_hover:null,
		},
	};

	const final = deepMerge(base, stage?.layout_props ?? {});

	// ANSWER
	applyValueNotNull(final.answer, 'color', base, () => {
		return promo_layout_props.link.color;
	});
	applyValueNotNull(final.answer, 'background_color', base, () => {
		return `rgba(${colorToArray(promo_layout_props.color.text_color)}, 0.03)`;
	});
	applyValueNotNull(final.answer, 'border_width', base, () => {
		return '1';
	});
	applyValueNotNull(final.answer, 'border_color', base, () => {
		return `rgba(${colorToArray(promo_layout_props.color.text_color)}, 0.1)`;
	});
	applyValueNotNull(final.answer, 'color_hover', base, () => {
		return promo_layout_props.link.color_hover;
	});
	applyValueNotNull(final.answer, 'background_color_hover', base, () => {
		return `rgba(${colorToArray(promo_layout_props.color.text_color)}, 0.1)`;
	});
	applyValueNotNull(final.answer, 'border_color_hover', base, () => {
		return `rgba(${colorToArray(final.answer.border_color)}, 0.1)`;
	});
	applyValueNotNull(final.answer, 'tick_color', base, () => {
		return promo_layout_props.color.text_color;
	});
	applyValueNotNull(final.answer, 'tick_bg_color', base, () => {
		return (isColorBright(final.answer.tick_color)) ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)';
	});
	applyValueNotNull(final.answer, 'color_selected', base, () => {
		return final.answer.color_hover;
	});
	applyValueNotNull(final.answer, 'background_color_selected', base, () => {
		return final.answer.background_color_hover;
	});
	applyValueNotNull(final.answer, 'border_color_selected', base, () => {
		return final.answer.border_color;
	});

	// CONTINUE BUTTON
	applyValueNotNull(final.continue, 'override_styles', base, () => {
		return false;
	});
	applyValueNotNull(final.continue, 'color', base, () => {
		return promo_layout_props.button.color;
	});
	applyValueNotNull(final.continue, 'background_color', base, () => {
		return promo_layout_props.button.background_color;
	});
	applyValueNotNull(final.continue, 'color_hover', base, () => {
		return promo_layout_props.button.color_hover;
	});
	applyValueNotNull(final.continue, 'background_color_hover', base, () => {
		return promo_layout_props.button.background_color_hover;
	});

	return final;
};

export function getLayout(promotion, type = 'FULL') {
	const is_promotion = ((promotion?.config_styles ?? false) !== false) ? true : false;

	const inferred = {};

	const boolean = [
		'text.h1_force_uppercase',
		'text.h2_force_uppercase',
		'text.h3_force_uppercase',
		'text.h3_force_uppercase',
		'container.shadow',
		'container.full_on_mobile',
		'button.force_uppercase',
		'link.force_uppercase',
		'field_label.force_uppercase',
		'header.display_icons',
		'header.display_my_networks',
		'header.sticky',
	];

	const base = {
		color:{
			main_color:'rgba(30, 34, 170, 1)',
			secondary_color:null,				// color.main_color
			text_color:'rgba(0, 0, 0, 1)',
			background_color:null,				// promotion.bg_color_tab
			container_color:'rgba(255, 255, 255, 1)',
			error_color:'rgba(215, 35, 60, 1)',
		},
		text:{
			block_width:'100',					// in "%"
			font_size_multiplier:'1',
			text_align:'center',
			text_align_flex:'center',			// text.text_align (in flexbox values)
			main_font:null,
			main_font_type:null,
			main_font_light:null,
			main_font_roman:null,
			main_font_bold:null,
			secondary_font:null,
			secondary_font_type:null,
			secondary_font_light:null,
			secondary_font_roman:null,
			secondary_font_bold:null,

			h1_color:null,						// color.text_color
			h1_font_size:1.5,
			h1_line_height:1.4,
			h1_font_family:'main',
			h1_font_weight:'roman',
			h1_force_uppercase:false,
			h1_text_align:null,					// text.text_align

			h2_color:null,						// color.text_color
			h2_font_size:1.25,
			h2_line_height:1.4,
			h2_font_family:'main',
			h2_font_weight:'roman',
			h2_force_uppercase:false,
			h2_text_align:null,					// text.text_align

			h3_color:null,						// color.text_color
			h3_font_size:1.1,
			h3_line_height:1.4,
			h3_font_family:'main',
			h3_font_weight:'roman',
			h3_force_uppercase:false,
			h3_text_align:null,					// text.text_align

			p_color:null,						// color.text_color
			p_font_size:1,
			p_line_height:1.4,
			p_font_family:'main',
			p_font_weight:'roman',
			p_text_align:null,					// text.text_align

			ul_padding_start:2,
			ul_padding_end:0,
			ul_list_style:'none',
			ul_list_style_custom:'➡️ ',
			ul_margin_bottom:0.4,
			ul_block_width:100,

			sections_text_align:'center',
		},
		button:{
			size:'25em',
			color:null,							// isColorLight(button.background_color)
			background_color:null,				// color.main_color
			border_radius:'0.2',				// in "em"
			border_width:null,			 		// in "px"
			border_color:null,					// button.background_color
			color_hover:null,					// button.color
			background_color_hover:null,		// color.secondary_color || button.background_color
			border_color_hover:null,			// button.border_color
			force_uppercase:true,
			font_family:'secondary',
			font_weight:'roman',
			background_image:null,
		},
		link:{
			color:null,							// button.background_color
			color_hover:null,					// color.secondary_color
			decoration:'none',
			decoration_hover:'underline',
			force_uppercase:true,
			font_family:'secondary',
			font_weight:'roman',
		},
		field:{
			border_radius:'0.2',				// in "em"
			background_color:'transparent',
			color:null,							// color.text_color
			border_color:null,					// color.text_color
			border_width:'1',					// in "px"
			border_type:'all',
			font_family:'main',
			font_weight:'roman',
			font_size:1,
		},
		field_label:{
			color:null,							// color.text_color
			font_family:'secondary',
			font_weight:'roman',
			font_size:0.8,
			force_uppercase:true,
		},
		container:{
			border_radius:'0',					// in "em"
			border_width:'0',
			border_color:null,					// color.main_color
			padding:'1.2',						// in "em"
			margin:'0',							// in "em"
			anchor:'cc',
			height:'adapt',
			shadow:false,
			full_on_mobile:false,
		},
		layer:{
			color:null,
			background_color:null,				// color.container_color
			link_color:null,					// button.background_color
			overlay_color:'rgba(0, 0, 0, 0.8)',
			header_background_color:null,		// layer.color @ 3%
			header_color:null,					// white | black depending on header_background_color
			border_radius:0.2,					// in "rem"
		},
		background:{
			background_color:null,				// color.main_color
			ink_color:null,						// color.main_color
			apply_ink:null,
			anchor:'tc',
			repeat:'cover',
			blend_mode:'normal',
			background_image:null,
			background_image_mobile:null,
		},
		header:{
			display:null,
			type:null,
			color:null,							// text.color
			link_color:null,					// link.color
			link_color_hover:null,				// link.color_hover
			link_background_color_hover:null,	// color.main_color
			background_color:null,				// color.container_color
			menu_background_color:'rgba(0, 0, 0, 1)',
			menu_background_color_hover:null,
			menu_cover_background_color:null,	// altered header.menu_background_color
			menu_color:'rgba(255, 255, 255, 1)',
			menu_color_hover:null,				// header.menu_color
			menu_border_width:'1',
			menu_border_style:'solid',
			menu_border_color:'rgba(255, 255, 255, 0.2)',
			border_width:'1',
			border_color:null,
			display_icons:true,
			display_my_networks:true,
			logo_image:null,
			logo_url:null,
			menu_position:'row',
			menu_icon:'burguer',
			sticky:true,
			tall_header:false,
		},
		footer:{
			display:null,
			color:null,							// header.color
			link_color:null,					// header.link_color
			link_color_hover:null,				// header.link_color_hover
			background_color:null,				// header.background_color
			border_width:'1',					// header.border_width
			border_color:null,					// header.border_color
			sponsors_image:null,
			sponsors_url:null,
		},
		loyalty:{
			text_color:null,					// color.text_color
			link_color:null,					// link.color
			border_color:null,					// loyalty.text_color
			border_width:0,
			background_color:'transparent',
		},
		other:{
			selection_color:null,				// color.secondary_color
			selection_bg_color:null,
			ribbon_open_background_color:'rgba(120, 195, 0, 1)',
			ribbon_open_text_color:'rgba(255, 255, 255, 1)',
			ribbon_open_border_color:null,		// other.ribbon_open_text_color
			ribbon_pending_background_color:'rgba(35, 48, 190, 1)',
			ribbon_pending_text_color:'rgba(255, 255, 255, 1)',
			ribbon_pending_border_color:null,	// other.ribbon_pending_text_color
			ribbon_closed_background_color:'rgba(215, 35, 60, 1)',
			ribbon_closed_text_color:'rgba(255, 255, 255, 1)',
			ribbon_closed_border_color:null,	// other.ribbon_closed_text_color
		},
	};

	if(is_promotion) {
		const old_values = {
			color:{
				main_color:'config_styles.promotion.style.main_color_bg',
				text_color:'config_styles.promotion.style.secondary_color_bg',
				container_color:'config.layout.bg_color',
				//background_color:'bg_color_tab',
			},
			text:{
				text_align:'config.layout.text_align',
				main_font:'config_styles.promotion.style.mainfont',
				main_font_css:'config_styles.promotion.style.mainfontcss',
				main_font_uri:'config_styles.promotion.style.mainfont_uri',
				main_font_light:'config_styles.promotion.style.mainfontWeightLight',
				main_font_roman:'config_styles.promotion.style.mainfontWeightRoman',
				main_font_bold:'config_styles.promotion.style.mainfontWeightBold',
				secondary_font:'config_styles.promotion.style.secondaryfont',
				secondary_font_css:'config_styles.promotion.style.secondaryfontcss',
				secondary_font_uri:'config_styles.promotion.style.secondary_font_uri',
				secondary_font_light:'config_styles.promotion.style.secondaryfontWeightRoman',
				secondary_font_roman:'config_styles.promotion.style.secondaryfontWeightRoman',
				secondary_font_bold:'config_styles.promotion.style.secondaryfontWeightRoman',
			},
			container:{
				anchor:'config.layout.container_align',
				height:'config.layout.height',
			},
			layer:{
				color:'config_styles.promotion.style.layer_text_color',
				background_color:'config_styles.promotion.style.layer_bg_color',
				//link_color:'config_styles.promotion.style.layer_main_color',
			},
			background:{
				//background_color:'bg_color_tab',
				background_image:'bg_image_tab',
				full_background_image:'full_bg_image_tab',
				opacity:'config.promotion_default_opacity',
				anchor:'config.promotion_default_position',
				repeat:'bg_repeat_tab',
			},
		};

		Object.keys(old_values).map((scope) => {
			Object.keys(old_values[scope]).map((key) => {
				applyValue(base[scope], key, promotion, old_values[scope][key]);
				extractInferred(inferred, scope, key, promotion, old_values[scope][key]);
			});
		});
	}

	const final = deepMerge(base, promotion?.layout_props ?? {});

	applyObject(final, boolean, ensureBoolean);

	if(is_promotion) {
		// LEGACY FUNCTIONS
		applyValueLegacy(final.header, 'display', (current) => {
			if(final.header.display != undefined) return current;
			return displayPromoHeader(promotion);
		},inferred,'header');
		applyValueLegacy(final.header, 'type', (current) => {
			if(final.header.type != undefined) return current;
			if(promotion.menu_as_tabs != undefined && promotion.menu_as_tabs) return 'tab';
			//return promotion?.menu_layout ?? 'classic';
			return 'classic';
		},inferred,'header');
		applyValueLegacy(final.background, 'full_bg_image_tab', (current) => {
			if(final.background.full_background_image == undefined) return null;
			if(final.background.full_background_image == undefined) return null;
			return (final.background.full_background_image.indexOf('current') == -1) ? final.background.full_background_image : null;
		},inferred,'background');
		applyValueLegacy(final.text, 'main_font_type', (current) => {
			if(final.text.main_font_type != undefined) return current;
			return (promotion.config_styles.promotion.style.mainfontgoogle == 'true') ? 'google' : 'system';
		},inferred,'text');
		applyValueLegacy(final.text, 'secondary_font_type', (current) => {
			if(final.text.secondary_font_type != undefined) return current;
			return (promotion.config_styles.promotion.style.secondaryfontgoogle == 'true') ? 'google' : 'system';
		},inferred,'text');
		applyValueLegacy(final.color, 'container_color', (current) => {
			if(current == 'wt') return `rgba(255, 255, 255, ${parseInt(promotion.config.layout?.alpha ?? '100') / 100})`;
			if(current == 'bl') return `rgba(0, 0, 0, ${parseInt(promotion.config.layout?.alpha ?? '100') / 100})`;
			return current;
		},inferred,'color');
		applyValueLegacy(final.text, 'text_align', (current) => {
			if(current == 'cl') return 'start';
			if(current == 'cc') return 'center';
			if(current == 'cr') return 'end';
			return current;
		},inferred,'text');
		applyValueLegacy(final.background, 'apply_ink', (current) => {
			if(final.background.apply_ink != undefined) return current;
			return (parseInt(promotion.config?.promotion_default_opacity ?? '100') < 100) ? true : false;
		},inferred,'background');
		applyValueLegacy(final.color, 'background_color', (current) => {
			if(final.color.background_color != undefined) return current;

			let bg_color_opacity = parseInt(promotion.config?.promotion_default_opacity ?? '100');
			if(promotion.bg_image_tab != '') bg_color_opacity = 0;
			return `rgba(${colorToArray(promotion.bg_color_tab)}, ${1 - bg_color_opacity / 100})`;
		},inferred,'color');
		applyValueLegacy(final.background, 'ink_color', (current) => {
			if(String(final.background.apply_ink) != "true") return null;
			if(final.background.ink_color != undefined) return current;
			return `rgba(${colorToArray(promotion.bg_color_tab)}, ${1 - parseInt(promotion.config?.promotion_default_opacity ?? '100') / 100})`;
		},inferred,'background');
		applyValueLegacy(final.footer, 'display', (current) => {
			if(final.footer.display != undefined) return current;
			return isFooterOn(promotion);
		},inferred,'footer');
		applyValueLegacy(final.layer, 'link_color', (current) => {
			if(final.layer.link_color != undefined) return current;
			const promo_value = promotion?.config_styles?.promotion?.style?.layer_main_color ?? null;
			if(promo_value == final.color.main_color) return null;
			return promo_value;
		},inferred,'layer');

		// fixing the old "lined_buttons" configuration:
		if((promotion.config?.layout?.button ?? 'solid') == 'lined') {
			applyValueNotNull(final.button, 'color', base, 'color.main_color',inferred,'button');
			applyValueNotNull(final.button, 'border_width', base, () => {
				return '2';
			},inferred,'button');
			applyValueNotNull(final.button, 'border_color', base, 'color.main_color',inferred,'button');
			applyValueNotNull(final.button, 'background_color', base, () => {
				return `rgba(${colorToArray(final.color.main_color)}, 0)`;
			},inferred,'button');
			applyValueNotNull(final.button, 'background_color_hover', base, () => {
				return `rgba(${colorToArray(final.color.main_color)}, 0.2)`;
			},inferred,'button');
		}
	}

	// COLORS
	applyValueNotNull(final.color, 'secondary_color', base, 'color.main_color');

	// TEXT
	applyValueNotNull(final.text, 'main_font', base, () => { return 'Nunito+Sans'; });
	applyValueNotNull(final.text, 'main_font_css', base, () => { return '"Nunito Sans", sans-serif'; });
	applyValueNotNull(final.text, 'main_font_type', base, () => { return 'google'; });
	applyValueNotNull(final.text, 'main_font_light', base, () => { return '100'; });
	applyValueNotNull(final.text, 'main_font_roman', base, () => { return '400'; });
	applyValueNotNull(final.text, 'main_font_bold', base, () => { return '700'; });
	applyValueNotNull(final.text, 'secondary_font', base, () => { return 'Montserrat'; });
	applyValueNotNull(final.text, 'secondary_font_css', base, () => { return '"Montserrat", sans-serif'; });
	applyValueNotNull(final.text, 'secondary_font_type', base, () => { return 'google'; });
	applyValueNotNull(final.text, 'secondary_font_light', base, () => { return '100'; });
	applyValueNotNull(final.text, 'secondary_font_roman', base, () => { return '400'; });
	applyValueNotNull(final.text, 'secondary_font_bold', base, () => { return '700'; });
	applyValueNotNull(final.text, 'h1_color', base, 'color.text_color');
	applyValueNotNull(final.text, 'h2_color', base, 'color.text_color');
	applyValueNotNull(final.text, 'h3_color', base, 'color.text_color');
	applyValueNotNull(final.text, 'p_color', base, 'color.text_color');
	applyValueNotNull(final.text, 'h1_text_align', base, 'text.text_align');
	applyValueNotNull(final.text, 'h2_text_align', base, 'text.text_align');
	applyValueNotNull(final.text, 'h3_text_align', base, 'text.text_align');
	applyValueNotNull(final.text, 'p_text_align', base, 'text.text_align');

	// BUTTON
	applyValueNotNull(final.button, 'background_color', base, 'color.main_color');
	applyValueNotNull(final.button, 'color', base, () => {
		if((promotion?.config_styles?.promotion?.style?.secondary_color_text ?? false) !== false) {
			return `rgba(${colorToArray(promotion.config_styles.promotion.style.secondary_color_text, true)})`;
		}
		return (isColorBright(final.button.background_color)) ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)';
	});
	applyValueNotNull(final.button, 'border_color', base, 'button.background_color');
	applyValueNotNull(final.button, 'background_color_hover', base, () => {
		if(final.color.secondary_color == final.button.background_color) {
			return (isColorBright(final.button.background_color)) ? darkenMainColorByPercent(0.2, final.button.background_color) : lightenMainColorByPercent(0.3, final.button.background_color);
		}

		return final.color.secondary_color;
	});
	applyValueNotNull(final.button, 'color_hover', base, () => {
		return `rgba(${colorToArray(final.button.color)}, 0.8)`;
	});
	applyValueNotNull(final.button, 'border_color_hover', base, 'button.border_color');
	applyValueNotNull(final.button, 'background_color_disabled', base, () => {
		return (!isColorBright(final.button.background_color)) ? darkenMainColorByPercent(0.5, final.button.background_color) : lightenMainColorByPercent(0.6, final.button.background_color);
	});
	applyValueNotNull(final.button, 'color_disabled', base, () => {
		return final.button.color;
	});
	applyValueNotNull(final.button, 'border_color_disabled', base, 'button.border_color');
	applyValueNotNull(final.button, 'border_width', base, () => {
		return '0';
	});

	// LINK
	applyValueNotNull(final.link, 'color', base, 'color.main_color');
	applyValueNotNull(final.link, 'color_hover', base, 'color.secondary_color');

	// CONTAINER
	applyValueNotNull(final.container, 'border_color', base, 'color.main_color');

	// FIELD
	applyValueNotNull(final.field, 'color', base, 'color.text_color');
	applyValueNotNull(final.field, 'border_color', base, 'field.color');

	// FIELD LABEL
	applyValueNotNull(final.field_label, 'color', base, 'color.text_color');

	// LAYER
	applyValueNotNull(final.layer, 'background_color', base, 'color.container_color');
	applyValueNotNull(final.layer, 'color', base, () => {
		return (isColorBright(final.layer.background_color)) ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)';
	});
	applyValueNotNull(final.layer, 'link_color', base, 'color.main_color');
	applyValueNotNull(final.layer, 'header_background_color', base, () => {
		return `rgba(${colorToArray(final.layer.color)}, 0.03)`;
	});
	applyValueNotNull(final.layer, 'header_color', base, () => {
		return (isColorBright(final.layer.header_background_color)) ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)';
	});

	// BACKGROUND
	applyValueNotNull(final.background, 'ink_color', base, () => {
		return `rgba(${colorToArray(final.color.background_color)}, 0.5)`;
	});

	// HEADER
	applyValueNotNull(final.header, 'link_color', base, 'link.color');
	applyValueNotNull(final.header, 'link_color_hover', base, () => {
		return `rgba(${colorToArray(final.header.link_color)}, 0.8)`;
	});
	applyValueNotNull(final.header, 'link_background_color_hover', base, () => {
		return `rgba(${colorToArray(final.color.main_color)}, 0.2)`;
	});
	applyValueNotNull(final.header, 'link_background_color_hover', base, () => {
		return `rgba(${colorToArray(final.color.main_color)}, 0.2)`;
	});
	applyValueNotNull(final.header, 'background_color', base, () => {
		return `rgba(${colorToArray(final.color.container_color)}, 0.9)`;
	});
	applyValueNotNull(final.header, 'border_color', base, () => {
		return (isColorBright(final.color.container_color)) ? 'rgba(0, 0, 0, 0.3)' : 'rgba(255, 255, 255, 0.3)';
	});
	applyValueNotNull(final.header, 'menu_color_hover', base, 'header.menu_color');
	applyValueNotNull(final.header, 'menu_background_color_hover', base, () => {
		return `rgba(${colorToArray(final.header.menu_color)}, 0.15)`;
	});
	applyValueNotNull(final.header, 'menu_cover_background_color', base, () => {
		return darkenMainColorByPercent(0.85, final.header.menu_background_color);
	});

	// FOOTER
	applyValueNotNull(final.footer, 'background_color', base, 'header.background_color');
	applyValueNotNull(final.footer, 'border_color', base, 'header.border_color');
	applyValueNotNull(final.footer, 'border_width', base, 'header.border_width');
	applyValueNotNull(final.footer, 'link_color', base, 'header.link_color');
	applyValueNotNull(final.footer, 'link_color_hover', base, () => {
		return `rgba(${colorToArray(final.footer.link_color)}, 0.8)`;
	});

	// LOYALTY
	applyValueNotNull(final.loyalty, 'text_color', base, 'color.text_color');
	applyValueNotNull(final.loyalty, 'link_color', base, 'link.color');
	applyValueNotNull(final.loyalty, 'border_color', base, 'loyalty.text_color');

	// OTHER
	applyValueNotNull(final.other, 'selection_bg_color', base, 'color.secondary_color');
	applyValueNotNull(final.other, 'selection_color', base, () => {
		return (isColorBright(final.other.selection_bg_color)) ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)';
	});
	applyValueNotNull(final.other, 'ribbon_open_border_color', base, () => {
		return `rgba(${colorToArray(final.other.ribbon_open_text_color)}, 0.2)`;
	});
	applyValueNotNull(final.other, 'ribbon_pending_border_color', base, () => {
		return `rgba(${colorToArray(final.other.ribbon_pending_text_color)}, 0.2)`;
	});
	applyValueNotNull(final.other, 'ribbon_closed_border_color', base, () => {
		return `rgba(${colorToArray(final.other.ribbon_closed_text_color)}, 0.2)`;
	});

	if(is_promotion) {
		const inferred_layout_props = deepMerge(inferred, promotion.layout_props ?? {});
		if(type == 'INFERRED') return inferred_layout_props;
	}

	return final;
}
window.getLayout = getLayout;

function applyObject (object,paths,func) {
	paths.map(path=>{
		const route = path.split('.');
		let current = object;
		let last = object;
		let name;
		for (var i in route) {
			name = route[i];
			if (current[name] == undefined) return;
			if (i == (route.length -1)) last = current;
			current = current[name];
		}
		last[name] = func(current);
	})
}



function applyValueNotNull(target, key, object, path, inferred, section) {
	if(target[key] != null) return;
	const res = applyValue(target, key, object, path);
	if (inferred != undefined) {
		if (inferred[section]==undefined) inferred[section] = {};
		applyValue(inferred[section],key,object,path);
	}
	return res;
}


function applyValue(target,key,object,path) {
	if (typeof path === 'function') {
		target[key] = path();
		return;
	}

	const route = path.split('.');
	let current = object;
	for (var i in route) {
		const name = route[i];
		if (current[name] == undefined) return null;
		current = current[name];
	}
	target[key] = current;
}

function extractInferred(target,section,key,object,path) {
	if (typeof path === 'function') {
		if (target[section] == undefined) target[section] = {}
		target[section][key] = path();
		return;
	}

	const route = path.split('.');
	let current = object;
	for (var i in route) {
		const name = route[i];
		if (current[name] == undefined) return null;
		current = current[name];
	}
	if (target[section] == undefined) target[section] = {}
	target[section][key] = current;
}

function applyValueLegacy(target, key, convert,inferred,section) {
	const converted = convert(target[key]);
	if(converted == undefined || convert == null) return;

	target[key] = converted;
	if(inferred[section] == undefined) inferred[section] = {};
	inferred[section][key] = target[key];
}

export function isAppOld(type_id) {
	const old_apps = ['2', '3', '4', '10', '13', '15', '17', '19', '20'];
	return (old_apps.includes(type_id)) ? true : false;
};

export function deepMerge(base,merge) {
	const operations = {}
	
	for (var key in merge) {

		var oldValue = base[key];
		var newValue = merge[key];

		if (typeof(oldValue) === 'object' && typeof(newValue) === 'object') {
			base[key] = deepMerge(oldValue,newValue);
		}
		else if (typeof(oldValue) === 'object' && oldValue !== null) {
			base[key] = {...oldValue}
		}
		else {
			operations[key]=newValue;
			base[key] = newValue;
		}
	}
	return base;
}

export function dynamicSort(field, reverse, primer) {
	const key = primer ?
		function(x) {
		return primer(x[field])
		} :
		function(x) {
		return x[field]
		};

	reverse = !reverse ? 1 : -1;

	return function(a, b) {
		return a = key(a), b = key(b), reverse * ((a > b) - (b > a));
	}
}

class DomRenderSingleton {
	constructor() {
		if(typeof DomRenderSingleton.instance === "object") return DomRenderSingleton.instance;
		this.nodes = {};

		DomRenderSingleton.instance = this;
		return this;
	}

	render(children, element) {
		if(element == undefined) element = 'root';

		if(this.nodes[element] == undefined) {
			const container = document.getElementById(element);
			this.nodes[element] = createRoot(container); 
		}

		this.nodes[element].render(children);
	}
};

export const DOMRender = (children, element) => {
	if(true) {
		// replace "false" with "true" if needed to rollback
		ReactDOM.render(
			children,
			document.getElementById(element),
		);
		return;
	}

	(new DomRenderSingleton()).render(children, element);
};

export const isDesktop = () => {
	if(window.is_mobile != undefined) {
		// user_react.ctp
		return (window.is_mobile()) ? false : true;
	}

	if((window?.platform ?? 'desktop') == 'desktop') {
		// user_flex.ctp
		return true;
	}

	return false;
};

export const isIOS = () => {
	return (/iphone|ipad|ipod/i.test(navigator.userAgent)) ? true : false;
};

export const getDeviceFromUserAgent = (user_agent) => {
	if(user_agent == undefined || user_agent == '') return "-";

	const ua = user_agent.toLowerCase();
	if(ua.indexOf("android") > -1) return "Android";
	if(ua.indexOf("iphone") > -1) return "iPhone";
	return "Desktop";
};

export const isJSON = (value) => {
	// Si no es una cadena, definitivamente no es un JSON válido
	if(typeof value !== 'string') return false;

	try {
		const resultado = JSON.parse(value);
		// La siguiente línea es necesaria porque JSON.parse() aceptará
		// valores como números o booleanos, que no son objetos JSON.
		return (typeof resultado === 'object' && resultado !== null);
	} catch (e) {
		return false; // No es un JSON válido
	}
};

export const migrate_question = (map, game, question) => {
	if(game == undefined) return false;

	let migrated = false;
	for(let i in map) {
		if(question.config[i] == undefined) continue;
		if(game[map[i]] != undefined) continue;

		migrated = true;
		let value = question.config[i];

		if(map[i] == 'matchit_images') {
			const pairs = [];
			question.config[i].map((image) => {
				const existing = pairs.find((i) => i[0].name == image.name);

				if(!existing) {
					pairs.push([{
						name:image.name,
						image:image.image,
						full:image.full,
						order:image.order,
					}]);

					return;
				}

				existing.push({
					name:image.name,
					image:image.image,
					full:image.full,
					order:image.order,
				});
			})

			value = pairs;
		}

		if(map[i] == 'hidden_areas') {
			const zones = [];
			question.config[i].map((zone, index) => {
				zones.push({
					name:zone.name ?? `Area ${index}`,
					points:zone.points,
					x:zone.x,
					y:zone.y,
					type:'hidden_area',
					id:uuidv4(),
				});
			})

			value = zones;
		}
		
		game[map[i]] = value;
	}

	if(game?.puzzle_image != undefined) {
		if(Array.isArray(game?.puzzle_image) && game.puzzle_image.length > 0) {
			game.full_puzzle_image = game.puzzle_image[0].full;
			game.puzzle_image = game.puzzle_image[0].image;
		}
	}

	if(isNotEmpty(question,'image') && [23,24].includes(game.promotion_type_id)) {
		game.memory_backflip_image = question?.image;
		game.full_memory_backflip_image = question?.fullimage;
	}

	if(game?.hidden_image == undefined  && isNotEmpty(question.config,'images') && question.config.images.length > 0) {
		game.hidden_image = question.config.images[0].image;
		game.full_hidden_image =  question.config.images[0].full;
	}

	return migrated;
};

export const available_locales = () => {
	if(window.langs == undefined) return [];
	
	const avail_locales = [];
	window.langs.map((loc) => {
		avail_locales.push(loc.I18nPromotion.lang);
	})
	return avail_locales;
};

export const truncate_string = (str, maxLength) => {
	if(str.length <= maxLength) return str;

	// Split the string into words
	const words = str.split(" ");

	let truncatedString = "";
	let i = 0;

	// Add words until the maximum length is reached or exceeded
	while(i < words.length && (truncatedString.length + words[i].length) <= maxLength) {
		truncatedString += ((i > 0) ? " " : "") + words[i];
		i++;
	}

	// Add ellipsis if the original string was truncated
	if(truncatedString.length < str.length) {
		truncatedString += "...";
	}

	return truncatedString;
};

export const orderBy = (elements, field, direction = 'asc', type = 'string') => {
	const dir = (direction || 'asc').toString().toLowerCase();
	const getValue = (item) => {
	  const valor = item[field];
  
	  switch (type) {
		case 'number': {
		  const n = Number(valor);
		  return isNaN(n) ? -Infinity : n;
		}
		case 'date': {
		  const d = new Date(valor).getTime();
		  return isNaN(d) ? -Infinity : d;
		}
		case 'string':
		default:
		  return valor?.toString().toLowerCase?.() || '';
	  }
	};
  
	return [...elements].sort((a, b) => {
	  const valorA = getValue(a);
	  const valorB = getValue(b);
	  if (valorA < valorB) return dir == 'asc' ? -1 : 1;
	  if (valorA > valorB) return dir == 'asc' ? 1 : -1;
	  return 0;
	});
  }

